import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "../App.css";
import $ from "jquery";
import { toast } from "react-toastify";
import { getEquipmentServiceUpdateTypeList } from "../Actions/EquipmentManagementAPI";
import {
    getEquipmentNameList,
    getEquipmentDropDownList,
    getPortNameList,
    getApplicableServiceTypeList,
    getApplicableServiceTypeListWithInterval,
    getEquipmentServiceTypeListWithInterval,
    getServiceDates,
    getEquipmentNameListAndId,
    getMakeList,
    getModelsList,
    getModelsOtherList
} from "../Actions/helpersAPI";
import {
    postAnnualCertificate,
    postBiannualCertificate,
    postFiveYearlyCertificate,
    postTenYearlyCertificate,
    deleteAttachmentInBucket
} from "../Actions/CommonAPI";
import {
    getPortAndCountry,
    getShipPortAndCountry,
    getAllShipPortAndCountry,
} from "../Actions/ServiceProviderAPI";
import {
    getEquipmentServiceTypeList,
    uploadAttachments,
} from "../Actions/CommonAPI";
import { postUpdateServiceImages } from "../Actions/ServiceUpdateAPI";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import API from "../helpers/api";
import moment from "moment";
import swal from "sweetalert";
import Autocomplete from "react-autocomplete";
import { confirmAlert } from "react-confirm-alert";
import AddIcon from "../UIComponents/AddIcon";
import MinusIcon from "../UIComponents/MinusIcon";
import Modal from "react-bootstrap/Modal";
import { validateFields } from "../Utils/utilities";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import { isNumberValid } from "../Common/CommonFunction";
import MaterialAutocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import i18n from "./DropdownLanguage/i18n";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
var fileDatas = [];
let valueCheck = false;

class editEquipment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modelOthers: false,
            equipmentServiceArray: false,
            isContractApplicableYes: false,
            isContractApplicableNo: true,
            openAlert: false,
            make: "",
            openOwnerRequirement: false,
            isOwner: true,
            modalIsOpen: false,
            ship: false,
            shore: false,
            equipmentId: 0,
            modelValidation: false,
            makeValidation: false,
            rescueMakeValidation: false,
            rescueModelValidation: false,
            rescueDavitMakeValidation: false,
            lifeMakeValidation: false,
            lifeModelValidation: false,
            lifeDavitMakeValidation: false,
            applicableServiceEquipType: [],
            equipmentinfo: {
                shipId: 0,
                isContractApplicable: false,
                equipmentId: 0,
                lifeboatMake: "",
                lifeboatModel: "",
                davitwinchMake: "",
                lifeboatMakeId: 0,
                lifeboatModelId: 0,
                davitwinchMakeId: 0,
                lifeboatRelease: "",
                rescueboatMake: "",
                rescueboatModel: "",
                rescueboatdavitwinchMake: "",
                rescueboatMakeId: 0,
                rescueboatModelId: 0,
                rescueboatdavitwinchMakeId: 0,
                rescueboatRelease: "",
                shipEquipmentId: 0,
                equipment: "",
                manufracturingDate: "",
                makeId: 0,
                modelId: 0,
                make: "",
                model: "",
                quantity: "",
                unit: "",
                equipmentType: "",
                capacity: "",
                category: "",
                serviceDetails: [],
                applicableTypes: [],
                createdBy: currentuser.name,
                equipmentCategoryType: '',
                equipmentContractTypeId: 0
            },
            annual: false,
            biannual: false,
            fiveyearly: false,
            tenyearly: false,
            serviceType: ["Annual", "Biannual", "Five Yearly", "Ten Yearly"],
            lastannualServiceCertificate: "",
            lastbiannualServiceCertificate: "",
            last5yearlyServiceCertificate: "",
            last10yearlyServiceCertificate: "",
            Annual: {
                serviceType: "annually",
                lastDonePort: "",
                attachmentName: "",
                attachmentGuid: "",
                lastDoneDate: "",
                nextDueDate: "",
            },
            Biannual: {
                serviceType: "biannually",
                lastDonePort: "",
                attachmentName: "",
                attachmentGuid: "",
                lastDoneDate: "",
                nextDueDate: "",
            },
            Fiveyearly: {
                serviceType: "fiveyearly",
                lastDonePort: "",
                attachmentName: "",
                attachmentGuid: "",
                lastDoneDate: "",
                nextDueDate: "",
            },
            Tenyearly: {
                serviceType: "tenyearly",
                lastDonePort: "",
                attachmentName: "",
                attachmentGuid: "",
                lastDoneDate: "",
                nextDueDate: "",
            },
            file1: "",
            file2: "",
            file3: "",
            file4: "",
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
            equipmentArray: [],
            index: 0,
            annualIndex: 0,
            biannualIndex: 0,
            fiveyearlyIndex: 0,
            tenyearlyIndex: 0,
            dropDown: {
                EquipmentName: "",
                EquipmentType: "",
                Category: "",
                Capacity: "",
                makeId: 0,
                davitwinchMakeId: 0,
            },
            interval: 0,
            serviceDate: "",
            AddServiceYear: [
                {
                    shipId: 0,
                    equipmentId: 0,
                    Id: 0,
                    serviceTypeId: 0,
                    serviceTypeName: "",
                    servicetypelist: [],
                    isShore: false,
                    isShip: false,
                    radioButton: "",
                    isDeleted: false,
                },
            ],
            MakeModelList: [
                {
                    id: 0,
                    name: "Others",
                },
            ],
            ServiceTypeList: [],
            selectedServiceYears: [],
            inValidFields: [],
            openPort: true,
            openServiceProvider: false,
            openModel: false,
            openEquipmentType: false,
            openLifeMake: false,
            openLifeBoatModel: false,
            openDavitMake: false,
            openEquipment: false,
            openRescueMake: false,
            rescueWinchMake: false,
            EquipmentServiceID: [],
            equipemntConfigTypeList: [],
            equipemntCategoryTypeList: [],
            selectedEquipmentTypes: []
        };
        this.handleManufacturingDate = this.handleManufacturingDate.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleAnnualServiceDate = this.handleAnnualServiceDate.bind(this);
        this.handleBiannualServiceDate = this.handleBiannualServiceDate.bind(this);
        this.handle5YearServiceDate = this.handle5YearServiceDate.bind(this);
        this.handle10YearServiceDate = this.handle10YearServiceDate.bind(this);
        this.handlenextAnnualServiceDate =
            this.handlenextAnnualServiceDate.bind(this);
        this.handlenextBiannualServiceDate =
            this.handlenextBiannualServiceDate.bind(this);
        this.handlenext5YearServiceDate =
            this.handlenext5YearServiceDate.bind(this);
        this.handlenext10YearServiceDate =
            this.handlenext10YearServiceDate.bind(this);
        this.openDatePicker = this.openDatePicker.bind(this);
        this.openannualDatePicker = this.openannualDatePicker.bind(this);
        this.openbiannualDatePicker = this.openbiannualDatePicker.bind(this);
        this.open5YearDatePicker = this.open5YearDatePicker.bind(this);
        this.open10YearDatePicker = this.open10YearDatePicker.bind(this);
        this.nextannualDatePicker = this.nextannualDatePicker.bind(this);
        this.nextbiannualDatePicker = this.nextbiannualDatePicker.bind(this);
        this.next5YearDatePicker = this.next5YearDatePicker.bind(this);
        this.next10YearDatePicker = this.next10YearDatePicker.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAnnualInputChange = this.handleAnnualInputChange.bind(this);
        this.handleBiannualInputChange = this.handleBiannualInputChange.bind(this);
        this.handleFiveYearlyInputChange =
            this.handleFiveYearlyInputChange.bind(this);
        this.handleTenYearlyInputChange =
            this.handleTenYearlyInputChange.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.AddEquipment = this.AddEquipment.bind(this);
        this.UpdateEquipment = this.UpdateEquipment.bind(this);
        this.renderPortTitle = this.renderPortTitle.bind(this);
        this.renderCountryTitle = this.renderCountryTitle.bind(this);
        this.renderServiceProviderTitle =
            this.renderServiceProviderTitle.bind(this);
        this.renderMakeTitle = this.renderMakeTitle.bind(this);
        this.renderModelTitle = this.renderModelTitle.bind(this);
        this.renderEquipmentTitle = this.renderEquipmentTitle.bind(this);
        this.renderEquipmentTypeTitle = this.renderEquipmentTypeTitle.bind(this);
    }
    async componentDidMount() {
        let _this = this;
        const { dispatch, EquipmentObject, editEquipment, match, t } = _this.props;
        this.getEquipmentType();
        if (EquipmentObject?.equipment) {
            this.state.dropDown.EquipmentName = EquipmentObject?.equipment;
            this.state.dropDown.Capacity = EquipmentObject.capacity;
            this.state.dropDown.Category = EquipmentObject.category;
            this.state.dropDown.EquipmentType = EquipmentObject.equipmentType;
            if (EquipmentObject?.equipment.toLowerCase().includes("lifeboat")) {
                $("#ModelHide").addClass("none");
                $("#MakeHide").addClass("none");
                $("#categoryequiptype").addClass("categorylifeboat");
                $("#LifeBoatEquipment").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment1").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment2").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment3").removeClass("lifeBoat-hide");
                this.state.dropDown.makeId = EquipmentObject.lifeboatMakeId ? EquipmentObject.lifeboatMakeId : 0;
                this.state.dropDown.davitwinchMakeId = EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0;
                this.setState({})
                dispatch(getEquipmentDropDownList(_this.state.dropDown));
            }
            else if (EquipmentObject?.equipment.toLowerCase().includes("rescue boat")) {
                $("#ModelHide").addClass("none");
                $("#MakeHide").addClass("none");
                $("#categoryequiptype").removeClass("categorylifeboat");
                $("#rescueboatEquipment").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment1").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment2").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment3").removeClass("lifeBoat-hide");
                this.state.dropDown.makeId = EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0;
                this.state.dropDown.davitwinchMakeId = EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0;
                this.setState({})
                dispatch(getEquipmentDropDownList(_this.state.dropDown));
            } else {
                $("#ModelHide").removeClass("none");
                $("#MakeHide").removeClass("none");
                $("#LifeBoatEquipment").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
                $("#rescueboatEquipment").addClass("lifeBoat-hide");
                $("#rescueboatEquipment1").addClass("lifeBoat-hide");
                $("#rescueboatEquipment2").addClass("lifeBoat-hide");
                $("#rescueboatEquipment3").addClass("lifeBoat-hide");
                this.state.dropDown.makeId = EquipmentObject.makeId ? EquipmentObject.makeId : 0;
                this.state.dropDown.davitwinchMakeId = 0;
                this.setState({})
                dispatch(getEquipmentDropDownList(_this.state.dropDown));
            }
        }
        if (EquipmentObject?.equipment) {
            if (EquipmentObject?.equipment.toLowerCase().includes("lifeboat")) {
                this.getEquipmentServiceTypeListbuilt(
                    EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
                    EquipmentObject.shipId,
                    EquipmentObject.lifeboatMakId ? EquipmentObject.lifeboatMakeId : 0,
                    EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0,
                    EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0,
                )
            } else if (EquipmentObject?.equipment.toLowerCase().includes("rescue boat")) {
                this.getEquipmentServiceTypeListbuilt(
                    EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
                    EquipmentObject.shipId,
                    EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0,
                    EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0,
                    EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0,
                )

            } else {
                this.getApplicableServiceTypeListbuilt(
                    EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
                    EquipmentObject.shipId,
                    EquipmentObject.makeId ? EquipmentObject.makeId : 0,
                    EquipmentObject.modelId ? EquipmentObject.modelId : 0
                )
            }
        }
        dispatch(getEquipmentNameListAndId());
        dispatch(getEquipmentNameList());
        dispatch(getPortNameList());
        this.getEquipmentCategoryType()
        //dispatch(getMakeList());
        if (
            match.path === "/Home/ShipManagementEditItem/:id/Equipment" ||
            match.path === "/Home/PendingShipEdit/:id/Equipment" ||
            match.path === "/Home/GrandAdmin/ShipEditItem/:id/Equipment"
        ) {
            dispatch(getEquipmentDropDownList(_this.state.dropDown));
        }
        if (
            match.path === "/Home/ShipManagementEditItem/:id/NewEquipment" ||
            match.path === "/Home/PendingShipEdit/:id/NewEquipment" ||
            match.path === "/Home/GrandAdmin/ShipEditItem/:id/NewEquipment"
        ) {
            this.props.dispatch({
                type: "getEquipmentDropDownListSuccess",
                data: null,
            });
            this.props.dispatch({ type: "getMakesListEquipmentSuccess", data: [] });
            this.props.dispatch({ type: "getModelsListEquipmentSuccess", data: [] });
        }
        dispatch(getAllShipPortAndCountry());
        if (editEquipment) {
            this.setState({ openOwnerRequirement: true });
        }
        await axios.get(`${API.GetServiceTypeList}`).then((res) => {
            let list = [];
            let serviceTypeList = [];
            res.data.map((item, index) => {
                let listItem = item.serviceTypes.split(" ");
                let order = (listItem[0]);
                let id = item.id;
                list.push({
                    id,
                    order,
                });
            });

            let mainList = list.sort(function (a, b) {
                return a.order - b.order;
            });
            mainList.map((item, i) => {
                let serviceTypes = item.order + " yearly";
                item = item.id;
                serviceTypeList.push({
                    item,
                    serviceTypes,
                });
            });
            this.state.AddServiceYear[0].servicetypelist = serviceTypeList;
            this.setState({ ServiceTypeList: serviceTypeList }, () => {
                /*  dispatch(
                  getEquipmentServiceUpdateTypeList(
                    EquipmentObject?.shipId,
                    EquipmentObject?.shipEquipmentId
                  )
                ); */
            });
        });
        $(document).on("keyup", "#quantity", function () {
            var pattern = /^(0|[0-9][0-9]*)$/;
            if (!pattern.test($("#quantity").val())) {
                $("#quantityErrMsg").text(`${t("ErrorMessage.InvalidMsg")}`);
                let invalid = _this.state.inValidFields;
                _this.setState({
                    invalidFields: invalid.push("quantity"),
                });
            } else {
                $("#quantityErrMsg").text("");
                let invalid = _this.state.inValidFields;
                let length = _this.state.inValidFields.length;
                var index = invalid.indexOf("quantity");
                if (index != -1) {
                    invalid.splice(index, length);
                }
                _this.setState({ invalidFields: invalid });
            }
        });

        // EquipmentObject.serviceDetails.map((f, index) => {
        //   let servicename = f.serviceType.replace(/ +/g, "");
        //
        //   let port = {
        //     port: f.lastDonePort,
        //     country: f.lastDoneCountry,
        //     serviceProvider: f.lastDoneServiceProvider,
        //     type: servicename,
        //   };
        //   dispatch(getShipPortAndCountry(port));
        // });
    }

    componentWillUnmount() {
        this.props.dispatch({
            type: "annualAttachmentUploadSuccess",
            data: undefined
        });
    }
    getEquipmentType = () => {
        // let url = `${API.equipmentLookups}?lookupType=equipmenttype`;
        // axios.get(url).then((response) => {
        //   this.setState({ equipemntConfigTypeList: response.data.list });
        // });
        let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
        axios.get(url).then((response) => {
            this.setState({ equipemntConfigTypeList: response.data || [] });
        });
    }
    componentDidUpdate() {
        window.onpopstate = (e) => {
            //your code...
            const { EquipmentArray } = this.props;
            this.props.dispatch({ type: "ShowSidePan", data: false });
            this.props.dispatch({
                type: "getEquipmentDetails",
                data: EquipmentArray,
            });
            // this.props.history.goBack();
        };
    }
    validateAndSetMessage(array1, array2) {
        const { t } = this.props;
        let hasError = false;
        if (!this.props.applicableServiceType) {
            return hasError;
        }

        this.props.applicableServiceType.forEach((i, index) => {
            // const item1 = array1[index];
            // const item2 = array2[index];
            const item1 = array1.find((x) => x?.serviceType === i.serviceType);
            const item2 = array2.find((x) => x?.serviceType === i.serviceType);

            // Check if either item1 or item2 is missing
            if (item1 || item2) {
                // If either item1 or item2 is missing, update error messages for both items
                if (!item1) {
                    $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
                    hasError = true;
                } else {
                    if (item1.equipmentContractTypeId === 0) {
                        $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
                        hasError = true;
                    } else {
                        $(`#equipmentContractTypeError${index}`).text("");
                    }
                }

                if (!item2) {
                    $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
                    $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
                    $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
                    $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
                    $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
                    hasError = true;
                } else {
                    // Validate fields for item2 if condition2 is met
                    if (!item2.lastDoneDate) {
                        $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
                        hasError = true;
                    } else {
                        $(`#lastDoneDateError${index}`).text("");
                    }

                    if (!item2.nextDueDate) {
                        $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
                        hasError = true;
                    } else {
                        $(`#nextDueDateError${index}`).text("");
                    }

                    if (!item2.lastDoneCountry) {
                        $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
                        hasError = true;
                    } else {
                        $(`#lastDoneCountryError${index}`).text("");
                    }

                    if (!item2.lastDonePort) {
                        $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
                        hasError = true;
                    } else {
                        $(`#lastDonePortError${index}`).text("");
                    }

                    if (!item2.lastDoneServiceProvider) {
                        $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
                        hasError = true;
                    } else {
                        $(`#lastDoneServiceProviderError${index}`).text("");
                    }

                    // Validate fields for item1 if condition1 is met

                }
            }
            else {
                $(`#lastDoneDateError${index}`).text(t('EquipPage.LastDoneDateIsRequired'));
                $(`#nextDueDateError${index}`).text(t('EquipPage.NextDueDateIsRequired'));
                $(`#lastDoneCountryError${index}`).text(t('EquipPage.LastDoneCountryIsRequired'));
                $(`#lastDonePortError${index}`).text(t('EquipPage.LastDonePortIsRequired'));
                $(`#lastDoneServiceProviderError${index}`).text(t('EquipPage.LastDoneServiceProviderIsRequired'));
                $(`#equipmentContractTypeError${index}`).text(t('EquipPage.EquipmentTypeIsRequired'));
                hasError = true;
            }
        });

        return hasError; // Return true if any validation failed, false otherwise
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            dispatch,
            annualAttachment,
            biannualAttachment,
            fiveyearlyAttachment,
            tenyearlyAttachment,
            EquipmentArray,
            applicableServiceType,
            EquipmentObject,
            ServiceDate,
            CountryList,
            PortList,
            ServiceProviderPortList,
            ServiceProviderId,
            serviceAttachment,
            editEquipment,
        } = nextProps;
        if (CountryList) {
            prevState["CountryList" + CountryList.type] = CountryList.data;
        }
        if (PortList) {
            prevState["PortList" + PortList.type] = PortList.data;
        }
        if (ServiceProviderPortList) {
            prevState["ServiceProviderList" + ServiceProviderPortList.type] =
                ServiceProviderPortList.data;
        }
        if (ServiceProviderId) {
            prevState["ServiceProviderId" + ServiceProviderId.type] =
                ServiceProviderId.data;
        }

        if (
            prevState.equipmentServiceArray &&
            applicableServiceType &&
            Array.isArray(applicableServiceType) &&
            applicableServiceType.length !== 0
        ) {
            prevState.equipmentServiceArray = false;
            applicableServiceType &&
                Array.isArray(applicableServiceType) &&
                applicableServiceType.map((f, index) => {
                    let servicename = f.serviceType?.replace(/ +/g, "");
                    let port = {
                        port: "",
                        country: "",
                        serviceProvider: "",
                        type: servicename,
                    };
                    dispatch(getShipPortAndCountry(port));
                });
        }

        if (EquipmentObject && EquipmentObject !== "") {
            prevState.AddServiceYear[0].shipId = EquipmentObject.shipId;
            prevState.AddServiceYear[0].equipmentId = EquipmentObject.equipmentId;
            prevState.equipmentinfo.equipmentContractTypeId = EquipmentObject?.equipmentContractTypeId ? EquipmentObject?.equipmentContractTypeId : 0;
            // prevState.equipmentinfo = EquipmentObject;
            prevState.equipmentinfo.shipId = EquipmentObject.shipId;
            prevState.equipmentinfo.equipmentId = EquipmentObject.equipmentId;
            prevState.equipmentinfo.shipEquipmentId = EquipmentObject.shipEquipmentId ? EquipmentObject.shipEquipmentId : 0;
            prevState.equipmentinfo.equipment = EquipmentObject.equipment;
            prevState.equipmentinfo.isContractApplicable = EquipmentObject?.isContractApplicable;
            prevState.isContractApplicableNo = EquipmentObject.isContractApplicable === false ? true : EquipmentObject.isContractApplicable === true ? false : false;
            prevState.isContractApplicableYes = EquipmentObject.isContractApplicable === true ? true : EquipmentObject.isContractApplicable === false ? false : false;
            prevState.equipmentinfo.lifeboatRelease = EquipmentObject.lifeboatRelease ? EquipmentObject.lifeboatRelease : "";
            prevState.equipmentinfo.davitwinchMake = EquipmentObject.davitwinchMake ? EquipmentObject.davitwinchMake : "";
            prevState.equipmentinfo.davitwinchMakeId = EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0;
            prevState.equipmentinfo.lifeboatMake = EquipmentObject.lifeboatMake ? EquipmentObject.lifeboatMake : "";
            prevState.equipmentinfo.lifeboatMakeId = EquipmentObject.lifeboatMakeId ? EquipmentObject.lifeboatMakeId : 0;
            prevState.equipmentinfo.lifeboatModel = EquipmentObject.lifeboatModel ? EquipmentObject.lifeboatModel : "";
            prevState.equipmentinfo.lifeboatModelId = EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0;
            prevState.equipmentinfo.rescueboatMake = EquipmentObject.rescueboatMake ? EquipmentObject.rescueboatMake : "";
            prevState.equipmentinfo.rescueboatMakeId = EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0;
            prevState.equipmentinfo.rescueboatModel = EquipmentObject.rescueboatModel ? EquipmentObject.rescueboatModel : "";
            prevState.equipmentinfo.rescueboatModelId = EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0;
            prevState.equipmentinfo.rescueboatdavitwinchMake = EquipmentObject.rescueboatdavitwinchMake ? EquipmentObject.rescueboatdavitwinchMake : "";
            prevState.equipmentinfo.rescueboatdavitwinchMakeId = EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0;
            prevState.equipmentinfo.rescueboatRelease = EquipmentObject.rescueboatRelease ? EquipmentObject.rescueboatRelease : "";
            prevState.equipmentinfo.manufracturingDate = EquipmentObject.manufracturingDate ? EquipmentObject.manufracturingDate : "";
            prevState.equipmentinfo.makeId = EquipmentObject.makeId ? EquipmentObject.makeId : 0;
            prevState.equipmentinfo.modelId = EquipmentObject.modelId ? EquipmentObject.modelId : 0;
            prevState.equipmentinfo.make = EquipmentObject.make ? EquipmentObject.make : "";
            prevState.equipmentinfo.model = EquipmentObject.model ? EquipmentObject.model : "";
            prevState.equipmentinfo.quantity = EquipmentObject.quantity;
            prevState.equipmentinfo.unit = EquipmentObject.unit;
            prevState.equipmentinfo.equipmentType = EquipmentObject.equipmentType;
            prevState.equipmentinfo.capacity = EquipmentObject.capacity;
            prevState.equipmentinfo.category = EquipmentObject.category;
            prevState.equipmentinfo.serviceDetails = EquipmentObject.serviceDetails;
            // prevState.equipmentinfo.equipmentTypeid = EquipmentObject.equipmentTypeid;

            prevState.index = EquipmentArray.findIndex(
                (x) => x.equipmentName === EquipmentObject.equipmentName
            );
            if (
                EquipmentObject.serviceDetails &&
                EquipmentObject.serviceDetails.length === 0
            ) {
                prevState.equipmentServiceArray = true;
            }

            EquipmentObject.serviceDetails.map((f, index) => {
                let servicename = f.serviceType?.replace(/ +/g, "");
                let port = {
                    port: f.lastDonePort,
                    country: f.lastDoneCountry,
                    serviceProvider: f.lastDoneServiceProvider,
                    type: servicename,
                };

                prevState["lastDoneCountry" + servicename] = f.lastDoneCountry;
                prevState["lastDoneServiceProvider" + servicename] =
                    f.lastDoneServiceProvider;
                prevState["lastDoneDate" + servicename] = f.lastDoneDate ? Moment(
                    new Date(Date.parse(f.lastDoneDate))
                ).format("YYYY-MM-DD") : "";
                prevState["lastDonePort" + servicename] = f.lastDonePort;
                prevState["nextDueDate" + servicename] = f.nextDueDate ? Moment(
                    new Date(Date.parse(f.nextDueDate))
                ).format("YYYY-MM-DD") : "";
                prevState["attachmentName" + servicename] = f.attachmentName;
                prevState["attachmentGuid" + servicename] = f.attachmentGuid;
                prevState["lastannualServiceCertificate" + servicename] =
                    f.attachmentName;
                prevState["equipmentServiceId" + servicename] = f.equipmentServiceId;
                dispatch(getShipPortAndCountry(port));
            });
            // EquipmentObject.applicableServices.map((item, index) => {
            //     if (!prevState.applicableServiceEquipType[index]) {
            //         prevState.applicableServiceEquipType[index] = { applicalbleEquipType: null, serviceTypeid: 0, serviceType: "" };
            //     }
            //     prevState.applicableServiceEquipType[index].applicalbleEquipType = { lookUpId: item.equipmentContractTypeId ?? 0, lookUpName: item.eqipmentContractTypeName ?? "" };
            //     prevState.applicableServiceEquipType[index].serviceTypeId = item.serviceTypeId ?? 0;
            //     prevState.applicableServiceEquipType[index].serviceType = item.serviceType ?? "";

            // })
            //dispatch({ type: "getServiceTypeListSuccess", data: null });
            // if (EquipmentObject?.equipment.toLowerCase().includes("lifeboat")) {
            //     editEquipment.getEquipmentServiceTypeListbuilt(
            //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
            //         EquipmentObject.shipId,
            //         EquipmentObject.lifeboatMakId ? EquipmentObject.lifeboatMakeId : 0,
            //         EquipmentObject.lifeboatModelId ? EquipmentObject.lifeboatModelId : 0,
            //         EquipmentObject.davitwinchMakeId ? EquipmentObject.davitwinchMakeId : 0,
            //     )
            // } else if (EquipmentObject?.equipment.toLowerCase().includes("rescue boat")) {
            //     editEquipment.getEquipmentServiceTypeListbuilt(
            //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
            //         EquipmentObject.shipId,
            //         EquipmentObject.rescueboatMakeId ? EquipmentObject.rescueboatMakeId : 0,
            //         EquipmentObject.rescueboatModelId ? EquipmentObject.rescueboatModelId : 0,
            //         EquipmentObject.rescueboatdavitwinchMakeId ? EquipmentObject.rescueboatdavitwinchMakeId : 0,
            //     )

            // } else {
            //     editEquipment.getApplicableServiceTypeListbuilt(
            //         EquipmentObject.equipmentId ? EquipmentObject.equipmentId : 0,
            //         EquipmentObject.shipId,
            //         EquipmentObject.makeId ? EquipmentObject.makeId : 0,
            //         EquipmentObject.modelId ? EquipmentObject.modelId : 0
            //     )
            // }
            dispatch({ type: "getEquipmentDetails", data: prevState.servicetype });
            // dispatch({ type: "getEquipmentDetails", data: "" });
        }

        if (valueCheck == false && prevState?.equipemntConfigTypeList?.length > 0) {
            valueCheck = true;
            const equipContractObj = prevState.equipemntConfigTypeList?.filter(r => r.lookUpId == prevState.equipmentinfo?.equipmentContractTypeId)[0];
            prevState.selectedEquipmentTypes = equipContractObj ? equipContractObj : [];
        }

        if (ServiceDate) {
            applicableServiceType &&
                applicableServiceType.map((servicename, index) => {
                    let servicenames = servicename?.serviceType?.replace(/ +/g, "");

                    if (servicenames === ServiceDate.serviceType) {
                        prevState["lastDoneDate" + servicenames] = ServiceDate.serviceDate ? Moment(
                            new Date(Date.parse(ServiceDate.serviceDate))
                        ).format("YYYY-MM-DD") : "";
                        prevState["nextDueDate" + servicenames] = ServiceDate.nextDueDate ? Moment(
                            new Date(Date.parse(ServiceDate.nextDueDate))
                        ).format("YYYY-MM-DD") : "";
                    }

                    dispatch({ type: "getServiceDateSuccess", data: null });
                });
        }
        // if (applicableServiceType) {
        //     applicableServiceType.map(r => {
        //         if (r.serviceType === "annually") {
        //             prevState.annual = true;
        //         }
        //         if (r.serviceType === "biannually") {
        //             prevState.biannual = true;
        //         }
        //         if (r.serviceType === "fiveyearly") {
        //             prevState.fiveyearly = true;
        //         }
        //         if (r.serviceType === "tenyearly") {
        //             prevState.tenyearly = true;
        //         }
        //     })
        // dispatch({ type: "getServiceTypeListSuccess", data: null });
        // }
        if (serviceAttachment && serviceAttachment !== "") {
            let servicename = serviceAttachment[0].Id?.replace(/ +/g, "");
            prevState["attachmentServicePhoto" + servicename] = serviceAttachment;
            dispatch({
                type: "serviceAttachmentUploadSuccess",
                data: "",
            });
        }
        if (annualAttachment) {
            let servicename = annualAttachment.Id.replace(/ +/g, "");
            prevState["attachmentName" + servicename] = annualAttachment.FileName;
            prevState["attachmentGuid" + servicename] = annualAttachment.Guid;
        }
        if (biannualAttachment) {
            prevState.Biannual.attachmentName = biannualAttachment.FileName;
            prevState.Biannual.attachmentGuid = biannualAttachment.Guid;
        }
        if (fiveyearlyAttachment) {
            prevState.Fiveyearly.attachmentName = fiveyearlyAttachment.FileName;
            prevState.Fiveyearly.attachmentGuid = fiveyearlyAttachment.Guid;
        }
        if (tenyearlyAttachment) {
            prevState.Tenyearly.attachmentName = tenyearlyAttachment.FileName;
            prevState.Tenyearly.attachmentGuid = tenyearlyAttachment.Guid;
        }
        if (EquipmentArray && EquipmentArray.length) {
            prevState.equipmentArray = EquipmentArray;
        }
        if (prevState.file1 !== "") {
            dispatch(postAnnualCertificate(prevState.file1));
            prevState.file1 = "";
        }
        if (prevState.file2 !== "") {
            dispatch(postBiannualCertificate(prevState.file2));
            prevState.file2 = "";
        }
        if (prevState.file3 !== "") {
            dispatch(postFiveYearlyCertificate(prevState.file3));
            prevState.file3 = "";
        }
        if (prevState.file4 !== "") {
            dispatch(postTenYearlyCertificate(prevState.file4));
            prevState.file4 = "";
        }
    }
    getApplicableServiceTypeListbuilt = (equipmentId, shipId, makeId, modelId) => {
        const { dispatch, EquipmentObject, editEquipment, match, t } = this.props;
        let url = `${API.ServiceTypeInterval}?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId}&modelId=${modelId}`;
        axios
            .get(url)
            .then((response) => {
                this.props.dispatch({
                    type: "getServiceTypeIntervalListSuccess",
                    data: response.data,
                });
                if (EquipmentObject.applicableServices.length === 0) {
                    response.data.forEach((_, index) => {
                        if (this.state.applicableServiceEquipType[index]) {
                            this.state.applicableServiceEquipType[index].applicableEquipType = {};
                        } else {
                            // Initialize an object if it doesn't exist at the current index
                            this.state.applicableServiceEquipType[index] = { applicableEquipType: {} };
                        }
                    });
                }
                else {
                    const updatedState = response.data.map(item => {
                        const match = EquipmentObject.applicableServices.find(
                            secondItem =>
                                secondItem.serviceTypeId === item.serviceTypeId &&
                                secondItem.serviceType === item.serviceType
                        );
                        // return match ? match : {};
                        if (match) {
                            console.log(match);
                            return {
                                applicableEquipType: {
                                    lookUpId: match.equipmentContractTypeId,
                                    lookUpName: match.equipmentContractTypeName
                                },
                                serviceType: match.serviceType,
                                serviceTypeId: match.serviceTypeId
                            }
                        }
                        else {
                            console.log("No match");
                            return {
                                applicableEquipType: {
                                    lookUpId: 0,
                                    lookUpName: ""
                                },
                                serviceType: "",
                                serviceTypeId: 0
                            }
                        }
                    });
                    this.setState({ applicableServiceEquipType: updatedState }, () => {
                        console.log(this.state.applicableServiceEquipType);
                    });
                }

            })
            .catch((error) => {
                this.props.dispatch({
                    type: "getServiceTypeIntervalListFailure",
                    error: "ERROR",
                });
            });
    };
    getEquipmentServiceTypeListbuilt = (equipmentId, shipId, makeId, modelId, davitwinchMakeId) => {
        const { dispatch, EquipmentObject, editEquipment, match, t } = this.props;
        let url = `${API.EquipmentServiceIntervalList}?shipid=${shipId}&equipmentId=${equipmentId}&makeId=${makeId ?? 0}&modelId=${modelId ?? 0}&davitWinchMakeId=${davitwinchMakeId ?? 0}`;
        axios
            .get(url)
            .then((response) => {
                this.props.dispatch({
                    type: "getServiceTypeIntervalListSuccess",
                    data: response.data,
                });
                if (EquipmentObject.applicableServices.length === 0) {
                    response.data.forEach((_, index) => {
                        if (this.state.applicableServiceEquipType[index]) {
                            this.state.applicableServiceEquipType[index].applicableEquipType = {};
                        } else {
                            // Initialize an object if it doesn't exist at the current index
                            this.state.applicableServiceEquipType[index] = { applicableEquipType: {} };
                        }
                    });
                }
                else {
                    const updatedState = response.data.map(item => {
                        const match = EquipmentObject.applicableServices.find(
                            secondItem =>
                                secondItem.serviceTypeId === item.serviceTypeId &&
                                secondItem.serviceType === item.serviceType
                        );
                        // return match ? match : {};
                        if (match) {
                            console.log(match);
                            return {
                                applicableEquipType: {
                                    lookUpId: match.equipmentContractTypeId,
                                    lookUpName: match.equipmentContractTypeName
                                },
                                serviceType: match.serviceType,
                                serviceTypeId: match.serviceTypeId
                            }
                        }
                        else {
                            console.log("No match");
                            return {
                                applicableEquipType: {
                                    lookUpId: 0,
                                    lookUpName: ""
                                },
                                serviceType: "",
                                serviceTypeId: 0
                            }
                        }
                    });
                    this.setState({ applicableServiceEquipType: updatedState }, () => {
                        console.log(this.state.applicableServiceEquipType);
                    });
                }

            })
            .catch((error) => {
                this.props.dispatch({
                    type: "getServiceTypeIntervalListFailure",
                    error: "ERROR",
                });
            });
    };
    populateState = () => {
        // const updatedState = this.props.applicableServiceType.map((service, index) => ({
        //     [service.serviceType]: this.state.applicableServiceEquipType[index] && this.state.applicableServiceEquipType[index].applicalbleEquipType
        //         ? this.state.applicableServiceEquipType[index].applicalbleEquipType
        //         : { lookUpId: 0, lookUpName: "" }
        // }));
        const updatedState = this.state.applicableServiceEquipType.map((service, index) => {
            // Ensure service is not null or undefined; provide default values if it is
            if (!service) {
                return {
                    serviceTypeId: 0,
                    serviceType: "",
                    equipmentContractTypeId: 0,
                    equipmentContractTypeName: ""
                };
            }

            // Ensure service.applicalbleEquipType exists before accessing properties
            const applicableEquipType = service.applicableEquipType || {};

            // Map the properties when `service` is defined
            return {
                serviceTypeId: service.serviceTypeId ?? 0,
                serviceType: service.serviceType ?? "",
                equipmentContractTypeId: applicableEquipType.lookUpId ?? 0,
                equipmentContractTypeName: applicableEquipType.lookUpName ?? ""
            };
        });
        this.state.equipmentinfo.applicableServices = updatedState;
    };

    checkArrayConditions(array1, array2) {
        // Check if the lengths of the arrays are the same
        if (array1.length !== array2.length) {
            return false;
        }

        // Check if all objects in `array1` satisfy the conditions
        const allValid = array1.every(obj =>
            obj.applicableEquipType && // Ensure the property exists
            obj.applicableEquipType.lookUpId !== 0 &&
            obj.applicableEquipType.lookUpName !== ''
        );

        return allValid;
    }

    AddEquipment() {
        this.populateState();
        // var applicablecheck = !this.checkArrayConditions(this.state.applicableServiceEquipType, this.props.applicableServiceType);
        console.log(this.state.equipmentinfo.applicableTypes);
        const { applicableServiceType, dispatch, match, t } = this.props;
        let serviceflag = false;
        const { params } = match;
        const { id } = params;
        if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
            if (this.state.equipmentinfo.davitwinchMake !== "" || this.state.equipmentinfo.lifeboatMake !== "" || this.state.equipmentinfo.lifeboatModel !== "") {
                if (this.state.equipmentinfo.davitwinchMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.davitwinchMake).length === 0) {
                        $("#LifeDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.lifeDavitMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeDavitValidationErrMsg").text("")
                        this.state.lifeDavitMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.lifeboatMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatMake).length === 0) {
                        $("#LifeMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.lifeMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeMakeValidationErrMsg").text("")
                        this.state.lifeMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.lifeboatModel !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatModel).length === 0) {
                        $("#LifeModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.lifeModelValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeModelValidationErrMsg").text("")
                        this.state.lifeModelValidation = false;
                        this.setState({})
                    }
                }
            }
        } else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {
            if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "" || this.state.equipmentinfo.rescueboatMake !== "" || this.state.equipmentinfo.rescueboatModel !== "") {
                if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatdavitwinchMake).length === 0) {
                        $("#rescueDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.rescueDavitMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueDavitValidationErrMsg").text("")
                        this.state.rescueDavitMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.rescueboatMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatMake).length === 0) {
                        $("#rescueMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.rescueMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueMakeValidationErrMsg").text("")
                        this.state.rescueMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.rescueboatModel !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatModel).length === 0) {
                        $("#rescueModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.rescueModelValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueModelValidationErrMsg").text("")
                        this.state.rescueModelValidation = false;
                        this.setState({})
                    }
                }
            }
        } else {
            if (this.state.equipmentinfo.make !== "" || this.state.equipmentinfo.model !== "") {
                if (this.state.equipmentinfo.make !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.make).length === 0) {
                        $("#MakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.makeValidation = true;
                        this.setState({})
                    } else {
                        $("#MakeValidationErrMsg").text("")
                        this.state.makeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.model !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.model).length === 0) {
                        $("#ModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.modelValidation = true;
                        this.setState({})
                    } else {
                        $("#ModelValidationErrMsg").text("")
                        this.state.modelValidation = false;
                        this.setState({})
                    }
                }
            }

        }
        if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
            if (
                this.state.equipmentinfo.lifeboatMake === "" ||
                this.state.equipmentinfo.lifeboatModel === "" ||
                this.state.equipmentinfo.davitwinchMake === "" ||
                this.state.equipmentinfo.lifeboatRelease === "" ||
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.unit === "" ||
                this.state.lifeDavitMakeValidation === true ||
                this.state.lifeMakeValidation === true ||
                this.state.lifeModelValidation === true //||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false 
                /* ||
       this.state.equipmentinfo.make === "" ||
       this.state.equipmentinfo.model === "" */
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.lifeboatMake === ""
                    ? $("#lifeboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeMakeValidationErrMsg").text("")
                    : $("#lifeboatmakeErrMsg").text("");
                this.state.equipmentinfo.lifeboatModel === ""
                    ? $("#lifeboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeModelValidationErrMsg").text("")
                    : $("#lifeboatmodelErrMsg").text("");
                this.state.equipmentinfo.davitwinchMake === ""
                    ? $("#davitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeDavitValidationErrMsg").text("")
                    : $("#davitwinchmakeErrMsg").text("");
                this.state.equipmentinfo.lifeboatRelease === ""
                    ? $("#lifeboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#lifeboatreleaseErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                /*  this.state.equipmentinfo.make === ""
                   ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                   : $("#MakeErrMsg").text("");
                 this.state.equipmentinfo.model === ""
                   ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                   : $("#ModelErrMsg").text(""); */
                return;
            } else {
                $("#LifeModelValidationErrMsg").text("");
                $("#LifeMakeValidationErrMsg").text("");
                $("#LifeDavitValidationErrMsg").text("");
                $("#EquipmentErrMsg").text("");
                $("#lifeboatmakeErrMsg").text("");
                $("#lifeboatmodelErrMsg").text("");
                $("#davitwinchmakeErrMsg").text("");
                $("#lifeboatreleaseErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                /*    $("#MakeErrMsg").text("");
                   $("#ModelErrMsg").text(""); */
                $("#EquipquantityErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePortid" + servicetype];
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["attachmentName"] =
                            this.state["attachmentName" + servicetype];
                        this.state.Annual["attachmentGuid"] =
                            this.state["attachmentGuid" + servicetype];
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        this.state.Annual["serviceImages"] = this.state[
                            "attachmentServicePhoto" + servicetype
                        ]
                            ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            })
                            : [];
                        this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                    // else {
                    //   serviceflag = true;
                    //   this.state.equipmentinfo.serviceDetails = [];
                    // }
                }
            }
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                let equip = {
                    shipId: parseInt(id),
                    equipmentName: this.state.equipmentinfo.equipment,

                    recentlyUpdated: true,
                    isContractApplicable: this.state.equipmentinfo.isContractApplicable,
                    lifeboatRelease: this.state.equipmentinfo.lifeboatRelease,
                    davitwinchMakeId: this.state.equipmentinfo.davitwinchMakeId ? parseInt(this.state.equipmentinfo.davitwinchMakeId) : 0,
                    lifeboatMakeId: this.state.equipmentinfo.lifeboatMakeId ? parseInt(this.state.equipmentinfo.lifeboatMakeId) : 0,
                    lifeboatModelId: this.state.equipmentinfo.lifeboatModelId ? parseInt(this.state.equipmentinfo.lifeboatModelId) : 0,
                    rescueboatMakeId: this.state.equipmentinfo.rescueboatMakeId ? parseInt(this.state.equipmentinfo.rescueboatMakeId) : 0,
                    rescueboatModelId: this.state.equipmentinfo.rescueboatModelId ? parseInt(this.state.equipmentinfo.rescueboatModelId) : 0,
                    rescueboatdavitwinchMakeId: this.state.equipmentinfo.rescueboatdavitwinchMakeId ? parseInt(this.state.equipmentinfo.rescueboatdavitwinchMakeId) : 0,
                    rescueboatRelease: this.state.equipmentinfo.rescueboatRelease ? this.state.equipmentinfo.rescueboatRelease : "",
                    dateOfBuild: this.state.equipmentinfo.manufracturingDate,
                    makeId: 0/* parseInt(this.state.equipmentinfo.makeId) */,
                    modelId: 0/* parseInt(this.state.equipmentinfo.modelId) */,
                    quantity: parseInt(this.state.equipmentinfo.quantity),
                    unit: this.state.equipmentinfo.unit,
                    equipmentType: this.state.equipmentinfo.equipmentType,
                    capacity: this.state.equipmentinfo.capacity,
                    category: this.state.equipmentinfo.category,
                    serviceDetails: this.state.equipmentinfo.serviceDetails,
                    applicableServices: this.state.equipmentinfo.applicableServices,
                    equipmentServiceIds: this.state.EquipmentServiceID,
                    createdBy: currentuser.name,
                    equipmentContractTypeId: this.state.equipmentinfo?.equipmentContractTypeId ? this.state.equipmentinfo?.equipmentContractTypeId : 0,
                };
                let equipArray = [];
                equipArray.push(equip);
                if (this.state.inValidFields.length === 0) {
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
                    let url = `${API.postShipEquipment}`;
                    axios
                        .post(url, equipArray)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${id}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "PostEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentAdd")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            this.setState({
                                EquipmentServiceID: []
                            }, () => {
                                console.log(this.state.EquipmentServiceID)
                            })
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "PostEquipmentDetailFailure",
                                data: "error",
                            });
                        });
                    this.setState({
                        ...this.state,
                        equipmentinfo: {
                            ...this.state.equipmentinfo,
                            quantity: parseInt(this.state.equipmentinfo.quantity)
                        }
                    }, () => {
                        this.state.equipmentArray.push(this.state.equipmentinfo);
                        this.props.dispatch({
                            type: "getEquipmentArray",
                            data: this.state.equipmentArray,
                        });
                        valueCheck = false;
                    })

                    console.log("equip", this.state.equipmentArray);
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }
        } else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {
            if (
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.rescueboatMake === "" ||
                this.state.equipmentinfo.rescueboatModel === "" ||
                this.state.equipmentinfo.rescueboatdavitwinchMake === "" ||
                this.state.equipmentinfo.rescueboatRelease === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.unit === "" ||
                this.state.rescueDavitMakeValidation === true ||
                this.state.rescueMakeValidation === true ||
                this.state.rescueModelValidation === true //||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false
                /* ||
                this.state.equipmentinfo.make === "" ||
                this.state.equipmentinfo.model === " " */
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.rescueboatMake === ""
                    ? $("#rescueboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueMakeValidationErrMsg").text("")
                    : $("#rescueboatmakeErrMsg").text("");
                this.state.equipmentinfo.rescueboatModel === ""
                    ? $("#rescueboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueModelValidationErrMsg").text("")
                    : $("#rescueboatmodelErrMsg").text("");
                this.state.equipmentinfo.rescueboatdavitwinchMake === ""
                    ? $("#rescueboatdavitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueDavitValidationErrMsg").text("")
                    : $("#rescueboatdavitwinchmakeErrMsg").text("");
                this.state.equipmentinfo.rescueboatRelease === ""
                    ? $("#rescueboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#rescueboatreleaseErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                /*  this.state.equipmentinfo.make === ""
                   ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                   : $("#MakeErrMsg").text("");
                 this.state.equipmentinfo.model === ""
                   ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                   : $("#ModelErrMsg").text(""); */
                return;
            } else {
                $("#rescueModelValidationErrMsg").text("");
                $("#rescueMakeValidationErrMsg").text("");
                $("#rescueDavitValidationErrMsg").text("");
                $("#EquipmentErrMsg").text("");
                $("#rescueboatmakeErrMsg").text("");
                $("#rescueboatmodelErrMsg").text("")
                $("#rescueboatdavitwinchmakeErrMsg").text("");
                $("#rescueboatreleaseErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                /*  $("#MakeErrMsg").text("");
                 $("#ModelErrMsg").text(""); */
                $("#EquipquantityErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePortid" + servicetype];
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["attachmentName"] =
                            this.state["attachmentName" + servicetype];
                        this.state.Annual["attachmentGuid"] =
                            this.state["attachmentGuid" + servicetype];
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        this.state.Annual["serviceImages"] = this.state[
                            "attachmentServicePhoto" + servicetype
                        ]
                            ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            })
                            : [];
                        this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                    // else {
                    //   serviceflag = true;
                    //   this.state.equipmentinfo.serviceDetails = [];
                    // }
                }
            }
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                let equip = {
                    shipId: parseInt(id),
                    equipmentName: this.state.equipmentinfo.equipment,
                    recentlyUpdated: true,
                    isContractApplicable: this.state.equipmentinfo.isContractApplicable,
                    lifeboatRelease: this.state.equipmentinfo.lifeboatRelease,
                    davitwinchMakeId: this.state.equipmentinfo.davitwinchMakeId ? parseInt(this.state.equipmentinfo.davitwinchMakeId) : 0,
                    lifeboatMakeId: this.state.equipmentinfo.lifeboatMakeId ? parseInt(this.state.equipmentinfo.lifeboatMakeId) : 0,
                    lifeboatModelId: this.state.equipmentinfo.lifeboatModelId ? parseInt(this.state.equipmentinfo.lifeboatModelId) : 0,
                    rescueboatMakeId: this.state.equipmentinfo.rescueboatMakeId ? parseInt(this.state.equipmentinfo.rescueboatMakeId) : 0,
                    rescueboatModelId: this.state.equipmentinfo.rescueboatModelId ? parseInt(this.state.equipmentinfo.rescueboatModelId) : 0,
                    rescueboatdavitwinchMakeId: this.state.equipmentinfo.rescueboatdavitwinchMakeId ? parseInt(this.state.equipmentinfo.rescueboatdavitwinchMakeId) : 0,
                    rescueboatRelease: this.state.equipmentinfo.rescueboatRelease ? this.state.equipmentinfo.rescueboatRelease : "",
                    dateOfBuild: this.state.equipmentinfo.manufracturingDate,
                    makeId: 0/* parseInt(this.state.equipmentinfo.makeId) */,
                    modelId: 0 /* parseInt(this.state.equipmentinfo.modelId) */,
                    quantity: parseInt(this.state.equipmentinfo.quantity),
                    unit: this.state.equipmentinfo.unit,
                    equipmentType: this.state.equipmentinfo.equipmentType,
                    capacity: this.state.equipmentinfo.capacity,
                    category: this.state.equipmentinfo.category,
                    serviceDetails: this.state.equipmentinfo.serviceDetails,
                    applicableServices: this.state.equipmentinfo.applicableServices,
                    equipmentServiceIds: this.state.EquipmentServiceID,
                    createdBy: currentuser.name,
                    equipmentContractTypeId: this.state.equipmentinfo?.equipmentContractTypeId ? this.state.equipmentinfo?.equipmentContractTypeId : 0,
                };
                let equipArray = [];
                equipArray.push(equip);
                if (this.state.inValidFields.length === 0) {
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
                    let url = `${API.postShipEquipment}`;
                    axios
                        .post(url, equipArray)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${id}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "PostEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentAdd")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            this.setState({
                                EquipmentServiceID: []
                            }, () => {
                                console.log(this.state.EquipmentServiceID)
                            })
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "PostEquipmentDetailFailure",
                                data: "error",
                            });
                        });
                    this.setState({
                        ...this.state,
                        equipmentinfo: {
                            ...this.state.equipmentinfo,
                            quantity: parseInt(this.state.equipmentinfo.quantity)
                        }
                    }, () => {
                        this.state.equipmentArray.push(this.state.equipmentinfo);
                        this.props.dispatch({
                            type: "getEquipmentArray",
                            data: this.state.equipmentArray,
                        });
                        valueCheck = false;
                    })
                    console.log("equip", this.state.equipmentArray);
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }

        }
        else {
            if (
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.make === "" ||
                this.state.equipmentinfo.model === "" ||
                this.state.equipmentinfo.unit === "" ||
                this.state.modelValidation === true ||
                this.state.makeValidation === true
                // ||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.make === ""
                    ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#MakeValidationErrMsg").text("")
                    : $("#MakeErrMsg").text("");
                this.state.equipmentinfo.model === ""
                    ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#ModelValidationErrMsg").text("")
                    : $("#ModelErrMsg").text("");
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                return;
            } else {
                $("#ModelValidationErrMsg").text("")
                $("#MakeValidationErrMsg").text("")
                $("#EquipmentErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#MakeErrMsg").text("");
                $("#ModelErrMsg").text("");
                $("#EquipquantityErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePortid" + servicetype];
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["attachmentName"] =
                            this.state["attachmentName" + servicetype];
                        this.state.Annual["attachmentGuid"] =
                            this.state["attachmentGuid" + servicetype];
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["serviceImages"] = this.state[
                            "attachmentServicePhoto" + servicetype
                        ]
                            ? this.state["attachmentServicePhoto" + servicetype].map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            })
                            : [];
                        this.state.equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                    // else {
                    //   serviceflag = true;
                    //   this.state.equipmentinfo.serviceDetails = [];
                    // }
                }
            }
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                let equip = {
                    shipId: parseInt(id),
                    equipmentName: this.state.equipmentinfo.equipment,
                    recentlyUpdated: true,
                    isContractApplicable: this.state.equipmentinfo.isContractApplicable,
                    dateOfBuild: this.state.equipmentinfo.manufracturingDate,
                    lifeboatRelease: this.state.equipmentinfo.lifeboatRelease,
                    rescueboatRelease: this.state.equipmentinfo.rescueboatRelease ? this.state.equipmentinfo.rescueboatRelease : "",
                    davitwinchMakeId: this.state.equipmentinfo.davitwinchMakeId ? parseInt(this.state.equipmentinfo.davitwinchMakeId) : 0,
                    lifeboatMakeId: this.state.equipmentinfo.lifeboatMakeId ? parseInt(this.state.equipmentinfo.lifeboatMakeId) : 0,
                    lifeboatModelId: this.state.equipmentinfo.lifeboatModelId ? parseInt(this.state.equipmentinfo.lifeboatModelId) : 0,
                    rescueboatMakeId: this.state.equipmentinfo.rescueboatMakeId ? parseInt(this.state.equipmentinfo.rescueboatMakeId) : 0,
                    rescueboatModelId: this.state.equipmentinfo.rescueboatModelId ? parseInt(this.state.equipmentinfo.rescueboatModelId) : 0,
                    rescueboatdavitwinchMakeId: this.state.equipmentinfo.rescueboatdavitwinchMakeId ? parseInt(this.state.equipmentinfo.rescueboatdavitwinchMakeId) : 0,
                    makeId: parseInt(this.state.equipmentinfo.makeId),
                    modelId: parseInt(this.state.equipmentinfo.modelId),
                    quantity: parseInt(this.state.equipmentinfo.quantity),
                    equipmentType: this.state.equipmentinfo.equipmentType,
                    capacity: this.state.equipmentinfo.capacity,
                    category: this.state.equipmentinfo.category,
                    unit: this.state.equipmentinfo.unit,
                    serviceDetails: this.state.equipmentinfo.serviceDetails,
                    applicableServices: this.state.equipmentinfo.applicableServices,
                    equipmentServiceIds: this.state.EquipmentServiceID,
                    createdBy: currentuser.name,
                    equipmentContractTypeId: this.state.equipmentinfo?.equipmentContractTypeId ? this.state.equipmentinfo?.equipmentContractTypeId : 0,
                };
                let equipArray = [];
                equipArray.push(equip);
                if (this.state.inValidFields.length === 0) {
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
                    let url = `${API.postShipEquipment}`;
                    axios
                        .post(url, equipArray)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${id}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "PostEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentAdd")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            this.setState({
                                EquipmentServiceID: []
                            }, () => {
                                console.log(this.state.EquipmentServiceID)
                            })
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "PostEquipmentDetailFailure",
                                data: "error",
                            });
                        });
                    this.setState({
                        ...this.state,
                        equipmentinfo: {
                            ...this.state.equipmentinfo,
                            quantity: parseInt(this.state.equipmentinfo.quantity)
                        }
                    }, () => {
                        this.state.equipmentArray.push(this.state.equipmentinfo);
                        this.props.dispatch({
                            type: "getEquipmentArray",
                            data: this.state.equipmentArray,
                        });
                        valueCheck = false;
                    })
                    console.log("equipcheck", equipArray);
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }
        }
        // } else {
        //   swal("Error!", "Service details is mandatory.", "warning");
        // }

        // const { Annual, Biannual, Fiveyearly, Tenyearly, annual, biannual, fiveyearly, tenyearly } = this.state;
        // const { dispatch, match } = this.props;
        // const { params } = match;
        // const { id } = params;
        // let serviceflag = false;
        // let equipArray = [];
        // if (this.state.annual) {
        //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
        //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
        //         this.state.equipmentinfo.serviceDetails.push(Annual);
        //     } else {
        //         serviceflag = true;
        //         this.state.equipmentinfo.serviceDetails = [];
        //     }
        // }
        // if (this.state.biannual) {
        //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
        //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
        //         this.state.equipmentinfo.serviceDetails.push(Biannual);
        //     } else {
        //         serviceflag = true;
        //         this.state.equipmentinfo.serviceDetails = [];
        //     }
        // }
        // if (this.state.fiveyearly) {
        //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
        //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
        //         this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
        //     } else {
        //         serviceflag = true;
        //         this.state.equipmentinfo.serviceDetails = [];
        //     }
        // }
        // if (this.state.tenyearly) {
        //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
        //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
        //         this.state.equipmentinfo.serviceDetails.push(Tenyearly);
        //     } else {
        //         serviceflag = true;
        //         this.state.equipmentinfo.serviceDetails = [];
        //     }
        // }
        // this.setState({});
        // let equip = {
        //     shipId: parseInt(id),
        //     equipmentName: this.state.equipmentinfo.equipment,
        //     dateOfBuild: this.state.equipmentinfo.manufracturingDate,
        //     make: this.state.equipmentinfo.make,
        //     model: this.state.equipmentinfo.model,
        //     quantity: this.state.equipmentinfo.quantity,
        //     equipmentType: this.state.equipmentinfo.equipmentType,
        //     capacity: this.state.equipmentinfo.capacity,
        //     category: this.state.equipmentinfo.category,
        //     serviceDetails: this.state.equipmentinfo.serviceDetails,
        //     createdBy: ''
        // }
        // equipArray.push(equip);
        // console.log("equip", equip)
        // if (!serviceflag && this.state.equipmentinfo.serviceDetails.length > 0) {
        //     let url = `${API.postShipEquipment}`;
        //     axios.post(url, equipArray)
        //         .then((response) => {
        //             let url = `${API.getShipEquipment}?shipId=${id}`;
        //             axios.get(url)
        //                 .then((response) => {
        //                     dispatch({
        //                         type: "getShipEquipmentDetailSuccess",
        //                         data: response.data,
        //                     })
        //                 })
        //                 .catch((error) => {
        //                     dispatch({
        //                         type: "getShipEquipmentDetailFailure",
        //                         error: "ERROR"
        //                     })
        //                 })
        //             this.hideSidePanel();
        //             dispatch({
        //                 type: 'PostEquipmentDetailSuccess',
        //                 data: response.data
        //             })
        //         }).catch((error) => {
        //             dispatch({
        //                 type: 'PostEquipmentDetailFailure',
        //                 data: "error"
        //             })
        //         })
        // } else {
        //     swal('Error!', 'Service details is mandatory.', 'warning');
        // }
    }

    UpdateEquipment() {
        this.populateState();
        // var applicablecheck = !this.checkArrayConditions(this.state.applicableServiceEquipType, this.props.applicableServiceType);
        let serviceflag = false;
        const { index, equipmentinfo } = this.state;
        const { applicableServiceType, dispatch, t } = this.props;
        let allServiceDetails = [];
        if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
            if (this.state.equipmentinfo.davitwinchMake !== "" || this.state.equipmentinfo.lifeboatMake !== "" || this.state.equipmentinfo.lifeboatModel !== "") {
                if (this.state.equipmentinfo.davitwinchMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.davitwinchMake).length === 0) {
                        $("#LifeDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.lifeDavitMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeDavitValidationErrMsg").text("")
                        this.state.lifeDavitMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.lifeboatMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatMake).length === 0) {
                        $("#LifeMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.lifeMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeMakeValidationErrMsg").text("")
                        this.state.lifeMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.lifeboatModel !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.lifeboatModel).length === 0) {
                        $("#LifeModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.lifeModelValidation = true;
                        this.setState({})
                    } else {
                        $("#LifeModelValidationErrMsg").text("")
                        this.state.lifeModelValidation = false;
                        this.setState({})
                    }
                }
            }
        } else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {
            if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "" || this.state.equipmentinfo.rescueboatMake !== "" || this.state.equipmentinfo.rescueboatModel !== "") {
                if (this.state.equipmentinfo.rescueboatdavitwinchMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatdavitwinchMake).length === 0) {
                        $("#rescueDavitValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.rescueDavitMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueDavitValidationErrMsg").text("")
                        this.state.rescueDavitMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.rescueboatMake !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatMake).length === 0) {
                        $("#rescueMakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.rescueMakeValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueMakeValidationErrMsg").text("")
                        this.state.rescueMakeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.rescueboatModel !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.rescueboatModel).length === 0) {
                        $("#rescueModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.rescueModelValidation = true;
                        this.setState({})
                    } else {
                        $("#rescueModelValidationErrMsg").text("")
                        this.state.rescueModelValidation = false;
                        this.setState({})
                    }
                }
            }
        } else {
            if (this.state.equipmentinfo.make !== "" || this.state.equipmentinfo.model !== "") {
                if (this.state.equipmentinfo.make !== "") {
                    let resultArray = this.props.MakeList?.length === 0 ? this.state.MakeModelList : this.props.MakeList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.make).length === 0) {
                        $("#MakeValidationErrMsg").text(t('CommonText.Pleaseselectvalidmake'))
                        this.state.makeValidation = true;
                        this.setState({})
                    } else {
                        $("#MakeValidationErrMsg").text("")
                        this.state.makeValidation = false;
                        this.setState({})
                    }
                }
                if (this.state.equipmentinfo.model !== "") {
                    let resultArray = this.props.ModelList?.length === 0 ? this.state.MakeModelList : this.props.ModelList;
                    if (resultArray.filter(item => item.name === this.state.equipmentinfo.model).length === 0) {
                        $("#ModelValidationErrMsg").text(t('CommonText.Pleaseselectvalidmodel'))
                        this.state.modelValidation = true;
                        this.setState({})
                    } else {
                        $("#ModelValidationErrMsg").text("")
                        this.state.modelValidation = false;
                        this.setState({})
                    }
                }
            }

        }
        if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
            if (
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.lifeboatMake === "" ||
                this.state.equipmentinfo.lifeboatModel === "" ||
                this.state.equipmentinfo.davitwinchMake === "" ||
                this.state.equipmentinfo.lifeboatRelease === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.unit === "" ||
                this.state.lifeDavitMakeValidation === true ||
                this.state.lifeMakeValidation === true ||
                this.state.lifeModelValidation === true //||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false 
                /*  ||
        this.state.equipmentinfo.make === "" ||
        this.state.equipmentinfo.model === "" */
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.lifeboatMake === ""
                    ? $("#lifeboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeMakeValidationErrMsg").text("")
                    : $("#lifeboatmakeErrMsg").text("");
                this.state.equipmentinfo.lifeboatModel === ""
                    ? $("#lifeboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeModelValidationErrMsg").text("")
                    : $("#lifeboatmodelErrMsg").text("");
                this.state.equipmentinfo.davitwinchMake === ""
                    ? $("#davitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#LifeDavitValidationErrMsg").text("")
                    : $("#davitwinchmakeErrMsg").text("");
                this.state.equipmentinfo.lifeboatRelease === ""
                    ? $("#lifeboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#lifeboatreleaseErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                /*   this.state.equipmentinfo.make === ""
                    ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#MakeErrMsg").text("");
                  this.state.equipmentinfo.model === ""
                    ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ModelErrMsg").text(""); */
                return;
            } else {
                $("#LifeModelValidationErrMsg").text("");
                $("#LifeMakeValidationErrMsg").text("");
                $("#LifeDavitValidationErrMsg").text("");
                $("#EquipmentErrMsg").text("");
                $("#lifeboatmakeErrMsg").text("");
                $("#lifeboatmodelErrMsg").text("");
                $("#davitwinchmakeErrMsg").text("");
                $("#lifeboatreleaseErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                /*   $("#MakeErrMsg").text("");
                  $("#ModelErrMsg").text(""); */
                $("#EquipquantityErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                this.state.equipmentinfo.serviceDetails = [];
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["lastDonePortid" + servicetype]
                                ? this.state["lastDonePortid" + servicetype]
                                : 0;
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDoneServiceProvider" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["attachmentName"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentName" + servicetype]
                                : "";
                        this.state.Annual["attachmentGuid"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentGuid" + servicetype]
                                : "";
                        this.state.Annual["equipmentServiceId"] =
                            this.state["equipmentServiceId" + servicetype];
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        // this.state.Annual["serviceImages"] =
                        //   this.state["attachmentServicePhoto" + servicetype];
                        let serviceImages =
                            this.state["attachmentServicePhoto" + servicetype];
                        if (serviceImages && serviceImages.length !== 0) {
                            serviceImages.map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            });
                            allServiceDetails = [...allServiceDetails, ...serviceImages];
                        }
                        equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                }
            }
            // if (!serviceflag && equipmentinfo.serviceDetails.length > 0) {
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                this.state.equipmentArray[index] = equipmentinfo;
                let equipList = [];
                let equip = {
                    shipId: equipmentinfo.shipId,
                    equipmentId: equipmentinfo.equipmentId,
                    shipEquipmentId: equipmentinfo.shipEquipmentId ? equipmentinfo.shipEquipmentId : 0,
                    recentlyUpdated: true,
                    isContractApplicable: equipmentinfo.isContractApplicable,
                    lifeboatRelease: equipmentinfo?.lifeboatRelease ? equipmentinfo?.lifeboatRelease : "",
                    davitwinchMakeId: equipmentinfo?.davitwinchMakeId ? equipmentinfo?.davitwinchMakeId : 0,
                    lifeboatMakeId: equipmentinfo?.lifeboatMakeId ? equipmentinfo?.lifeboatMakeId : 0,
                    lifeboatModelId: equipmentinfo?.lifeboatModelId ? equipmentinfo?.lifeboatModelId : 0,
                    rescueboatMakeId: equipmentinfo?.rescueboatMakeId ? equipmentinfo?.rescueboatMakeId : 0,
                    rescueboatModelId: equipmentinfo?.rescueboatModelId ? equipmentinfo?.rescueboatModelId : 0,
                    rescueboatdavitwinchMakeId: equipmentinfo?.rescueboatdavitwinchMakeId ? equipmentinfo?.rescueboatdavitwinchMakeId : 0,
                    rescueboatRelease: equipmentinfo?.rescueboatRelease ? equipmentinfo?.rescueboatRelease : "",
                    equipment: equipmentinfo.equipment,
                    unit: equipmentinfo.unit,
                    manufracturingDate: equipmentinfo.manufracturingDate,
                    makeId: 0 /* parseInt(equipmentinfo.makeId) */,
                    modelId: 0 /* parseInt(equipmentinfo.modelId) */,
                    quantity: parseInt(equipmentinfo.quantity),
                    serviceDetails: equipmentinfo.serviceDetails,
                    applicableServices: equipmentinfo.applicableServices,
                    equipmentType: equipmentinfo.equipmentType,
                    capacity: equipmentinfo.capacity,
                    category: equipmentinfo.category,
                    modifiedBy: currentuser.name,
                    isDeleted: false,
                    equipmentContractTypeId: equipmentinfo?.equipmentContractTypeId ? equipmentinfo?.equipmentContractTypeId : 0,
                    // equipmentTypeid: equipmentinfo.equipmentTypeid
                };
                equipList.push(equip);
                if (this.state.inValidFields.length === 0) {
                    if (allServiceDetails.length !== 0) {
                        dispatch(postUpdateServiceImages(allServiceDetails));
                    }
                    let url = `${API.postShipEquipment}`;
                    axios
                        .put(url, equipList)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "UpdateEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentUpdate")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "UpdateEquipmentDetailFailure",
                                data: "error",
                            });
                        });

                    this.props.dispatch({
                        type: "getEquipmentArray",
                        data: this.state.equipmentArray,
                    });
                    valueCheck = false;
                    console.log("equip", this.state.equipmentArray);
                    // this.hideSidePanel();
                    // } else {
                    //   swal("Error!", "Service details is mandatory.", "warning");
                    // }
                    this.setState({});

                    // const { equipmentinfo, annualIndex, biannualIndex, fiveyearlyIndex, tenyearlyIndex, index, Annual, Biannual, Fiveyearly, Tenyearly } = this.state;
                    // const { dispatch } = this.props;
                    // let serviceflag = false;
                    // if (this.state.annual) {
                    //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
                    //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Annual);
                    //         this.state.equipmentinfo.serviceDetails[annualIndex] = Annual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.biannual) {
                    //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
                    //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Biannual);
                    //         this.state.equipmentinfo.serviceDetails[biannualIndex] = Biannual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.fiveyearly) {
                    //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
                    //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
                    //         this.state.equipmentinfo.serviceDetails[fiveyearlyIndex] = Fiveyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.tenyearly) {
                    //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
                    //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Tenyearly);
                    //         this.state.equipmentinfo.serviceDetails[tenyearlyIndex] = Tenyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // this.setState({});
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails) {
                    //     let equipList = [];
                    //     let equip = {
                    //         shipId: equipmentinfo.shipId,
                    //         equipmentId: equipmentinfo.equipmentId,
                    //         shipEquipmentId: equipmentinfo.shipEquipmentId,
                    //         equipment: equipmentinfo.equipment,
                    //         manufracturingDate: equipmentinfo.manufracturingDate,
                    //         make: equipmentinfo.make,
                    //         model: equipmentinfo.model,
                    //         quantity: equipmentinfo.quantity,
                    //         serviceDetails: equipmentinfo.serviceDetails,
                    //         equipmentType: equipmentinfo.equipmentType,
                    //         capacity: equipmentinfo.capacity,
                    //         category: equipmentinfo.category,
                    //         modifiedBy: '',
                    //         isDeleted: false
                    //     }
                    //     equipList.push(equip);
                    //     console.log('equipList',equipList)
                    //     let url = `${API.postShipEquipment}`;
                    //     axios.put(url, equipList)
                    //         .then((response) => {
                    //             let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                    //             axios.get(url)
                    //                 .then((response) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailSuccess",
                    //                         data: response.data,
                    //                     })
                    //                 })
                    //                 .catch((error) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailFailure",
                    //                         error: "ERROR"
                    //                     })
                    //                 })
                    //             this.hideSidePanel();
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailSuccess',
                    //                 data: response.data
                    //             })
                    //         }).catch((error) => {
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailFailure',
                    //                 data: "error"
                    //             })

                    //         })

                    //     // this.state.equipmentArray[index] = equipmentinfo;
                    //     // this.setState({});
                    //     // this.props.dispatch({ type: "getShipEquipmentDetailSuccess", data: this.state.equipmentArray });
                    //     // this.hideSidePanel();
                    // } else {
                    //     swal('Error!', 'Service details is mandatory', 'warning');
                    // }
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }
        }
        else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {

            if (
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.rescueboatMake === "" ||
                this.state.equipmentinfo.rescueboatModel === "" ||
                this.state.equipmentinfo.rescueboatdavitwinchMake === "" ||
                this.state.equipmentinfo.rescueboatRelease === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.unit === "" ||
                this.state.rescueDavitMakeValidation === true ||
                this.state.rescueMakeValidation === true ||
                this.state.rescueModelValidation === true //||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false 
                /* ||
         this.state.equipmentinfo.make === "" ||
         this.state.equipmentinfo.model === " " */
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.rescueboatMake === ""
                    ? $("#rescueboatmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueMakeValidationErrMsg").text("")
                    : $("#rescueboatmakeErrMsg").text("");
                this.state.equipmentinfo.rescueboatModel === ""
                    ? $("#rescueboatmodelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueModelValidationErrMsg").text("")
                    : $("#rescueboatmodelErrMsg").text("");
                this.state.equipmentinfo.rescueboatdavitwinchMake === ""
                    ? $("#rescueboatdavitwinchmakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#rescueDavitValidationErrMsg").text("")
                    : $("#rescueboatdavitwinchmakeErrMsg").text("");
                this.state.equipmentinfo.rescueboatRelease === ""
                    ? $("#rescueboatreleaseErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#rescueboatreleaseErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                /*    this.state.equipmentinfo.make === ""
                     ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                     : $("#MakeErrMsg").text("");
                   this.state.equipmentinfo.model === ""
                     ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                     : $("#ModelErrMsg").text(""); */
                return;
            } else {
                $("#rescueModelValidationErrMsg").text("");
                $("#rescueMakeValidationErrMsg").text("");
                $("#rescueDavitValidationErrMsg").text("");
                $("#EquipmentErrMsg").text("");
                $("#rescueboatmakeErrMsg").text("");
                $("#rescueboatmodelErrMsg").text("");
                $("#rescueboatdavitwinchmakeErrMsg").text("");
                $("#rescueboatreleaseErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                /*   $("#MakeErrMsg").text("");
                  $("#ModelErrMsg").text(""); */
                $("#EquipquantityErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                this.state.equipmentinfo.serviceDetails = [];
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["lastDonePortid" + servicetype]
                                ? this.state["lastDonePortid" + servicetype]
                                : 0;
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDoneServiceProvider" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["attachmentName"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentName" + servicetype]
                                : "";
                        this.state.Annual["attachmentGuid"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentGuid" + servicetype]
                                : "";
                        this.state.Annual["equipmentServiceId"] =
                            this.state["equipmentServiceId" + servicetype];
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        // this.state.Annual["serviceImages"] =
                        //   this.state["attachmentServicePhoto" + servicetype];
                        let serviceImages =
                            this.state["attachmentServicePhoto" + servicetype];
                        if (serviceImages && serviceImages.length !== 0) {
                            serviceImages.map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            });
                            allServiceDetails = [...allServiceDetails, ...serviceImages];
                        }
                        equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                }
            }
            // if (!serviceflag && equipmentinfo.serviceDetails.length > 0) {
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                this.state.equipmentArray[index] = equipmentinfo;
                let equipList = [];
                let equip = {
                    shipId: equipmentinfo.shipId,
                    equipmentId: equipmentinfo.equipmentId,
                    shipEquipmentId: equipmentinfo.shipEquipmentId ? equipmentinfo.shipEquipmentId : 0,
                    recentlyUpdated: true,
                    isContractApplicable: equipmentinfo.isContractApplicable,
                    lifeboatRelease: equipmentinfo?.lifeboatRelease ? equipmentinfo?.lifeboatRelease : "",
                    davitwinchMakeId: equipmentinfo?.davitwinchMakeId ? equipmentinfo?.davitwinchMakeId : 0,
                    lifeboatMakeId: equipmentinfo?.lifeboatMakeId ? equipmentinfo?.lifeboatMakeId : 0,
                    lifeboatModelId: equipmentinfo?.lifeboatModelId ? equipmentinfo?.lifeboatModelId : 0,
                    rescueboatMakeId: equipmentinfo?.rescueboatMakeId ? equipmentinfo?.rescueboatMakeId : 0,
                    rescueboatModelId: equipmentinfo?.rescueboatModelId ? equipmentinfo?.rescueboatModelId : 0,
                    rescueboatdavitwinchMakeId: equipmentinfo?.rescueboatdavitwinchMakeId ? equipmentinfo?.rescueboatdavitwinchMakeId : 0,
                    rescueboatRelease: equipmentinfo?.rescueboatRelease ? equipmentinfo?.rescueboatRelease : "",
                    equipment: equipmentinfo.equipment,
                    unit: equipmentinfo.unit,
                    manufracturingDate: equipmentinfo.manufracturingDate,
                    makeId: 0/* parseInt(equipmentinfo.makeId) */,
                    modelId: 0 /* parseInt(equipmentinfo.modelId) */,
                    quantity: parseInt(equipmentinfo.quantity),
                    serviceDetails: equipmentinfo.serviceDetails,
                    applicableServices: equipmentinfo.applicableServices,
                    equipmentType: equipmentinfo.equipmentType,
                    capacity: equipmentinfo.capacity,
                    category: equipmentinfo.category,
                    modifiedBy: currentuser.name,
                    isDeleted: false,
                    equipmentContractTypeId: equipmentinfo?.equipmentContractTypeId ? equipmentinfo?.equipmentContractTypeId : 0,
                };
                equipList.push(equip);
                if (this.state.inValidFields.length === 0) {
                    if (allServiceDetails.length !== 0) {
                        dispatch(postUpdateServiceImages(allServiceDetails));
                    }
                    let url = `${API.postShipEquipment}`;
                    axios
                        .put(url, equipList)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "UpdateEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentUpdate")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "UpdateEquipmentDetailFailure",
                                data: "error",
                            });
                        });

                    this.props.dispatch({
                        type: "getEquipmentArray",
                        data: this.state.equipmentArray,
                    });
                    valueCheck = false;
                    console.log("equip", this.state.equipmentArray);
                    // this.hideSidePanel();
                    // } else {
                    //   swal("Error!", "Service details is mandatory.", "warning");
                    // }
                    this.setState({});

                    // const { equipmentinfo, annualIndex, biannualIndex, fiveyearlyIndex, tenyearlyIndex, index, Annual, Biannual, Fiveyearly, Tenyearly } = this.state;
                    // const { dispatch } = this.props;
                    // let serviceflag = false;
                    // if (this.state.annual) {
                    //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
                    //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Annual);
                    //         this.state.equipmentinfo.serviceDetails[annualIndex] = Annual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.biannual) {
                    //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
                    //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Biannual);
                    //         this.state.equipmentinfo.serviceDetails[biannualIndex] = Biannual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.fiveyearly) {
                    //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
                    //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
                    //         this.state.equipmentinfo.serviceDetails[fiveyearlyIndex] = Fiveyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.tenyearly) {
                    //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
                    //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Tenyearly);
                    //         this.state.equipmentinfo.serviceDetails[tenyearlyIndex] = Tenyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // this.setState({});
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails) {
                    //     let equipList = [];
                    //     let equip = {
                    //         shipId: equipmentinfo.shipId,
                    //         equipmentId: equipmentinfo.equipmentId,
                    //         shipEquipmentId: equipmentinfo.shipEquipmentId,
                    //         equipment: equipmentinfo.equipment,
                    //         manufracturingDate: equipmentinfo.manufracturingDate,
                    //         make: equipmentinfo.make,
                    //         model: equipmentinfo.model,
                    //         quantity: equipmentinfo.quantity,
                    //         serviceDetails: equipmentinfo.serviceDetails,
                    //         equipmentType: equipmentinfo.equipmentType,
                    //         capacity: equipmentinfo.capacity,
                    //         category: equipmentinfo.category,
                    //         modifiedBy: '',
                    //         isDeleted: false
                    //     }
                    //     equipList.push(equip);
                    //     console.log('equipList',equipList)
                    //     let url = `${API.postShipEquipment}`;
                    //     axios.put(url, equipList)
                    //         .then((response) => {
                    //             let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                    //             axios.get(url)
                    //                 .then((response) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailSuccess",
                    //                         data: response.data,
                    //                     })
                    //                 })
                    //                 .catch((error) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailFailure",
                    //                         error: "ERROR"
                    //                     })
                    //                 })
                    //             this.hideSidePanel();
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailSuccess',
                    //                 data: response.data
                    //             })
                    //         }).catch((error) => {
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailFailure',
                    //                 data: "error"
                    //             })

                    //         })

                    //     // this.state.equipmentArray[index] = equipmentinfo;
                    //     // this.setState({});
                    //     // this.props.dispatch({ type: "getShipEquipmentDetailSuccess", data: this.state.equipmentArray });
                    //     // this.hideSidePanel();
                    // } else {
                    //     swal('Error!', 'Service details is mandatory', 'warning');
                    // }
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }
        }
        else {
            console.log(isNumberValid(parseInt(this.state.equipmentinfo.quantity)), "isNumberValid(parseInt(this.state.equipmentinfo.quantity))")
            if (
                this.state.equipmentinfo.equipment === "" ||
                this.state.equipmentinfo.equipmentType === "" ||
                this.state.equipmentinfo.capacity === "" ||
                this.state.equipmentinfo.category === "" ||
                this.state.equipmentinfo.manufracturingDate === "" ||
                this.state.equipmentinfo.quantity === "" ||
                isNumberValid(parseInt(this.state.equipmentinfo.quantity)) === false ||
                this.state.equipmentinfo.make === "" ||
                this.state.equipmentinfo.model === "" ||
                this.state.equipmentinfo.unit === "" ||
                this.state.modelValidation === true ||
                this.state.makeValidation === true
                //||
                // this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false
            ) {
                this.state.equipmentinfo.equipment === ""
                    ? $("#EquipmentErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipmentErrMsg").text("");
                this.state.equipmentinfo.equipmentType === ""
                    ? $("#equipmenttypeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#equipmenttypeErrMsg").text("");
                this.state.equipmentinfo.capacity === ""
                    ? $("#capacityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#capacityErrMsg").text("");
                this.state.equipmentinfo.category === ""
                    ? $("#categoryErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#categoryErrMsg").text("");
                this.state.equipmentinfo.manufracturingDate === ""
                    ? $("#ManufactureDateErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#ManufactureDateErrMsg").text("");
                if (this.state.equipmentinfo.quantity === "") {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                } else if (isNumberValid(parseInt(this.state.equipmentinfo.quantity))) {
                    $("#EquipquantityErrMsg").text("")
                } else {
                    $("#EquipquantityErrMsg").text("");
                    $("#EquipquantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`)
                }
                this.state.equipmentinfo.make === ""
                    ? $("#MakeErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#MakeValidationErrMsg").text("")
                    : $("#MakeErrMsg").text("");
                this.state.equipmentinfo.model === ""
                    ? $("#ModelErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`) && $("#ModelValidationErrMsg").text("")
                    : $("#ModelErrMsg").text("");
                this.state.equipmentinfo.unit === ""
                    ? $("#EquipunitErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#EquipunitErrMsg").text("");
                this.state.isContractApplicableNo === false && this.state.isContractApplicableYes === false ?
                    $("#contractErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`)
                    : $("#contractErrMsg").text("");
                return;
            } else {
                $("#ModelValidationErrMsg").text("")
                $("#MakeValidationErrMsg").text("")
                $("#EquipmentErrMsg").text("");
                $("#categoryErrMsg").text("");
                $("#equipmenttypeErrMsg").text("");
                $("#capacityErrMsg").text("");
                $("#ManufactureDateErrMsg").text("");
                $("#MakeErrMsg").text("");
                $("#ModelErrMsg").text("");
                $("#EquipquantityErrMsg").text("");
                $("#EquipunitErrMsg").text("");
                $("#contractErrMsg").text("");
                $("#EquipmentTypeErrMsg").text('');
            }
            if (applicableServiceType && applicableServiceType.length > 0) {
                this.state.equipmentinfo.serviceDetails = [];
                for (var i = 0; i < applicableServiceType.length; i++) {
                    this.state.Annual = {};
                    var isShip = applicableServiceType[i].isShip;
                    var isShore = applicableServiceType[i].isShore;
                    var isOwner = applicableServiceType[i].isOwner;
                    var ServiceTypeId = applicableServiceType[i].serviceTypeId;
                    var EquipmentSerId = applicableServiceType[i].equipmentServiceId;
                    var newServiceType = applicableServiceType[i].serviceType;
                    var servicetype = applicableServiceType[i].serviceType?.replace(
                        / +/g,
                        ""
                    );
                    if (
                        this.state["lastDoneDate" + servicetype] ||
                        this.state["nextDueDate" + servicetype]
                    ) {
                        this.state.Annual["lastDoneDate"] =
                            this.state["lastDoneDate" + servicetype];
                        this.state.Annual["lastDonePort"] =
                            this.state["lastDonePort" + servicetype];
                        this.state.Annual["portId"] =
                            this.state["lastDonePort" + servicetype] &&
                                this.state["lastDonePortid" + servicetype]
                                ? this.state["lastDonePortid" + servicetype]
                                : 0;
                        this.state.Annual["serviceProviderId"] =
                            this.state["lastDoneServiceProvider" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype] &&
                                this.state["ServiceProviderId" + servicetype].length !== 0
                                ? this.state["ServiceProviderId" + servicetype][0]
                                    .serviceProviderId
                                : 0;
                        this.state.Annual["nextDueDate"] =
                            this.state["nextDueDate" + servicetype];
                        this.state.Annual["serviceType"] =
                            applicableServiceType[i].serviceType;
                        this.state.Annual["isShip"] = isShip;
                        this.state.Annual["isOwner"] = isOwner;
                        this.state.Annual["isShore"] = isShore;
                        this.state.Annual["serviceTypeId"] = ServiceTypeId;
                        this.state.Annual["serviceType"] = newServiceType;
                        this.state.Annual["equipmentServiceId"] = EquipmentSerId;
                        this.state.Annual["attachmentName"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentName" + servicetype]
                                : "";
                        this.state.Annual["attachmentGuid"] =
                            this.state["lastannualServiceCertificate" + servicetype] !== ""
                                ? this.state["attachmentGuid" + servicetype]
                                : "";
                        this.state.Annual["lastDoneCountry"] =
                            this.state["lastDoneCountry" + servicetype];
                        this.state.Annual["lastDoneServiceProvider"] =
                            this.state["lastDoneServiceProvider" + servicetype];
                        this.state.Annual["equipmentServiceId"] =
                            this.state["equipmentServiceId" + servicetype];
                        // this.state.Annual["serviceImages"] =
                        //   this.state["attachmentServicePhoto" + servicetype];
                        let serviceImages =
                            this.state["attachmentServicePhoto" + servicetype];
                        if (serviceImages && serviceImages.length !== 0) {
                            serviceImages.map((i) => {
                                i.equipmentServiceId =
                                    this.state["equipmentServiceId" + servicetype];
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                return i;
                            });
                            allServiceDetails = [...allServiceDetails, ...serviceImages];
                        }
                        equipmentinfo.serviceDetails.push(this.state.Annual);
                    }
                }
            }
            // if (!serviceflag && equipmentinfo.serviceDetails.length > 0) {
            let bool = this.validateAndSetMessage(this.state.equipmentinfo.applicableServices, this.state.equipmentinfo.serviceDetails);
            if (!bool) {
                this.state.equipmentArray[index] = equipmentinfo;
                let equipList = [];
                let equip = {
                    shipId: equipmentinfo.shipId,
                    equipmentId: equipmentinfo.equipmentId,
                    isContractApplicable: equipmentinfo.isContractApplicable,
                    recentlyUpdated: true,
                    shipEquipmentId: equipmentinfo.shipEquipmentId,
                    equipment: equipmentinfo.equipment,
                    lifeboatRelease: equipmentinfo?.lifeboatRelease ? equipmentinfo?.lifeboatRelease : "",
                    davitwinchMakeId: equipmentinfo?.davitwinchMakeId ? equipmentinfo?.davitwinchMakeId : 0,
                    lifeboatMakeId: equipmentinfo?.lifeboatMakeId ? equipmentinfo?.lifeboatMakeId : 0,
                    lifeboatModelId: equipmentinfo?.lifeboatModelId ? equipmentinfo?.lifeboatModelId : 0,
                    rescueboatMakeId: equipmentinfo?.rescueboatMakeId ? equipmentinfo?.rescueboatMakeId : 0,
                    rescueboatModelId: equipmentinfo?.rescueboatModelId ? equipmentinfo?.rescueboatModelId : 0,
                    rescueboatdavitwinchMakeId: equipmentinfo?.rescueboatdavitwinchMakeId ? equipmentinfo?.rescueboatdavitwinchMakeId : 0,
                    rescueboatRelease: equipmentinfo?.rescueboatRelease ? equipmentinfo?.rescueboatRelease : "",
                    manufracturingDate: equipmentinfo.manufracturingDate,
                    makeId: parseInt(equipmentinfo.makeId),
                    modelId: parseInt(equipmentinfo.modelId),
                    quantity: parseInt(equipmentinfo.quantity),
                    serviceDetails: equipmentinfo.serviceDetails,
                    applicableServices: equipmentinfo.applicableServices,
                    equipmentType: equipmentinfo.equipmentType,
                    unit: this.state.equipmentinfo.unit,
                    capacity: equipmentinfo.capacity,
                    category: equipmentinfo.category,
                    modifiedBy: currentuser.name,
                    isDeleted: false,
                    equipmentContractTypeId: equipmentinfo?.equipmentContractTypeId ? equipmentinfo?.equipmentContractTypeId : 0,
                };
                equipList.push(equip);
                if (this.state.inValidFields.length === 0) {
                    if (allServiceDetails.length !== 0) {
                        dispatch(postUpdateServiceImages(allServiceDetails));
                    }
                    let url = `${API.postShipEquipment}`;
                    axios
                        .put(url, equipList)
                        .then((response) => {
                            if (fileDatas.length > 0) {
                                this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                                fileDatas = [];
                            }
                            let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                            axios
                                .get(url)
                                .then((response) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailSuccess",
                                        data: response.data,
                                    });
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "getShipEquipmentDetailFailure",
                                        error: "ERROR",
                                    });
                                });
                            this.hideSidePanel();
                            dispatch({
                                type: "UpdateEquipmentDetailSuccess",
                                data: response.data,
                            });
                            toast.success(`${t("CommonText.EquipmentUpdate")}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        })
                        .catch((error) => {
                            // swal(
                            //     "Error!",
                            //     "Something went wrong. Please try again.",
                            //     "warning"
                            // );
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.500ErrorMessage'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                            dispatch({
                                type: "UpdateEquipmentDetailFailure",
                                data: "error",
                            });
                        });

                    this.props.dispatch({
                        type: "getEquipmentArray",
                        data: this.state.equipmentArray,
                    });
                    valueCheck = false;
                    console.log("equip", this.state.equipmentArray);
                    // this.hideSidePanel();
                    // } else {
                    //   swal("Error!", "Service details is mandatory.", "warning");
                    // }
                    this.setState({});

                    // const { equipmentinfo, annualIndex, biannualIndex, fiveyearlyIndex, tenyearlyIndex, index, Annual, Biannual, Fiveyearly, Tenyearly } = this.state;
                    // const { dispatch } = this.props;
                    // let serviceflag = false;
                    // if (this.state.annual) {
                    //     if (Annual.lastDoneDate !== '' && Annual.nextDueDate !== ''
                    //         && Annual.attachmentName !== '' && Annual.attachmentGuid !== '' && Annual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Annual);
                    //         this.state.equipmentinfo.serviceDetails[annualIndex] = Annual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.biannual) {
                    //     if (Biannual.lastDoneDate !== '' && Biannual.nextDueDate !== ''
                    //         && Biannual.attachmentName !== '' && Biannual.attachmentGuid !== '' && Biannual.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Biannual);
                    //         this.state.equipmentinfo.serviceDetails[biannualIndex] = Biannual;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.fiveyearly) {
                    //     if (Fiveyearly.lastDoneDate !== '' && Fiveyearly.nextDueDate !== ''
                    //         && Fiveyearly.attachmentName !== '' && Fiveyearly.attachmentGuid !== '' && Fiveyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Fiveyearly);
                    //         this.state.equipmentinfo.serviceDetails[fiveyearlyIndex] = Fiveyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // if (this.state.tenyearly) {
                    //     if (Tenyearly.lastDoneDate !== '' && Tenyearly.nextDueDate !== ''
                    //         && Tenyearly.attachmentName !== '' && Tenyearly.attachmentGuid !== '' && Tenyearly.lastDonePort !== '') {
                    //         // this.state.equipmentinfo.serviceDetails.push(Tenyearly);
                    //         this.state.equipmentinfo.serviceDetails[tenyearlyIndex] = Tenyearly;
                    //     } else {
                    //         serviceflag = true;
                    //     }
                    // }
                    // this.setState({});
                    // if (!serviceflag && this.state.equipmentinfo.serviceDetails) {
                    //     let equipList = [];
                    //     let equip = {
                    //         shipId: equipmentinfo.shipId,
                    //         equipmentId: equipmentinfo.equipmentId,
                    //         shipEquipmentId: equipmentinfo.shipEquipmentId,
                    //         equipment: equipmentinfo.equipment,
                    //         manufracturingDate: equipmentinfo.manufracturingDate,
                    //         make: equipmentinfo.make,
                    //         model: equipmentinfo.model,
                    //         quantity: equipmentinfo.quantity,
                    //         serviceDetails: equipmentinfo.serviceDetails,
                    //         equipmentType: equipmentinfo.equipmentType,
                    //         capacity: equipmentinfo.capacity,
                    //         category: equipmentinfo.category,
                    //         modifiedBy: '',
                    //         isDeleted: false
                    //     }
                    //     equipList.push(equip);
                    //     console.log('equipList',equipList)
                    //     let url = `${API.postShipEquipment}`;
                    //     axios.put(url, equipList)
                    //         .then((response) => {
                    //             let url = `${API.getShipEquipment}?shipId=${equipmentinfo.shipId}`;
                    //             axios.get(url)
                    //                 .then((response) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailSuccess",
                    //                         data: response.data,
                    //                     })
                    //                 })
                    //                 .catch((error) => {
                    //                     dispatch({
                    //                         type: "getShipEquipmentDetailFailure",
                    //                         error: "ERROR"
                    //                     })
                    //                 })
                    //             this.hideSidePanel();
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailSuccess',
                    //                 data: response.data
                    //             })
                    //         }).catch((error) => {
                    //             dispatch({
                    //                 type: 'UpdateEquipmentDetailFailure',
                    //                 data: "error"
                    //             })

                    //         })

                    //     // this.state.equipmentArray[index] = equipmentinfo;
                    //     // this.setState({});
                    //     // this.props.dispatch({ type: "getShipEquipmentDetailSuccess", data: this.state.equipmentArray });
                    //     // this.hideSidePanel();
                    // } else {
                    //     swal('Error!', 'Service details is mandatory', 'warning');
                    // }
                }
            }
            else {
                this.setState(prevState => ({
                    equipmentinfo: {
                        ...prevState.equipmentinfo, // spread the previous state to keep other properties intact
                        serviceDetails: [] // update serviceDetails with an empty array
                    }
                }));
            }
        }
    }
    // Equipment info

    isDuplicateShipEquipment(equipmentName, excludeIndex = -1) {
        const name = equipmentName?.trim().toLowerCase();
        if (!name) {
            return false;
        }
        const list = this.props.EquipmentArray || this.state.equipmentArray || [];
        return list.some(
            (item, idx) =>
                idx !== excludeIndex &&
                (item.equipment?.trim().toLowerCase() === name ||
                    item.equipmentName?.trim().toLowerCase() === name)
        );
    }

    showDuplicateEquipmentWarning(t) {
        swal({
            title: t("SwalError.ErrorTitle"),
            text: t("SwalError.ShipEquipmentExist"),
            icon: "warning",
            buttons: {
                confirm: {
                    text: t("confirmAlertMessage.Ok"),
                },
            },
        });
    }

    renderEquipmentTitle(state, val) {
        return (
            state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
        );
    }

    handleInputChanges(e, field) {
        if (field === "isContractApplicableYes") {
            this.state.isContractApplicableYes = true;
            this.state.equipmentinfo.isContractApplicable = true;
            this.state.isContractApplicableNo = false;
            this.setState({})
        } else if (field === "isContractApplicableNo") {
            this.state.isContractApplicableYes = false;
            this.state.equipmentinfo.isContractApplicable = false;
            this.state.isContractApplicableNo = true;
            this.setState({})
        } else if (field === "equipment") {
            if (e.target.value?.trim() == "") {
                this.state.equipmentinfo.equipmentContractTypeId = 0;
                this.state.selectedEquipmentTypes = [];
            }
        }
        this.state.equipmentinfo[field] = e.target.value;
        this.setState({});
    }

    onEquipmentTypeChange = (event, id, values) => {
        console.log(values, "values")
        this.state.selectedEquipmentTypes = values ? values : [];
        this.state.equipmentinfo.equipmentContractTypeId = id ? id : 0;
        this.setState({});
    };

    onEquipTypeChange = (e, values, serviceIndex, serviceName) => {
        let updated = [...this.state.applicableServiceEquipType]

        updated[serviceIndex] = {
            ...updated[serviceIndex],
            applicableEquipType: values || { lookUpId: 0, lookUpName: '' },
            serviceTypeId: serviceName.serviceTypeId,
            serviceType: serviceName.serviceType
        };
        this.setState({
            applicableServiceEquipType: updated
        },
            () => { console.log(this.state.applicableServiceEquipType, 'check') }
        );

    }

    addApplicableType = () => {
        const { dispatch, EquipmentObject, t } = this.props;
        if (this.state.AddServiceYear.length > 0) {
            let isValidMiscCharge = this.miscChargeValidation();
            if (!isValidMiscCharge) {
                return;
            }
            console.log(this.state.AddServiceYear);
        }
        let apiUrl = `${API.PostOwnerDetails}`;
        axios({
            method: "POST",
            url: apiUrl,
            data: this.state.AddServiceYear,
        })
            .then((response) => {
                if (response?.status === 200) {
                    let arrItems = response.data;
                    if (this.state.EquipmentServiceID.length === 0) {
                        this.setState({
                            EquipmentServiceID: arrItems
                        }, () => {
                            console.log("result", this.state.EquipmentServiceID)
                        })
                    } else {
                        this.setState({
                            EquipmentServiceID: [...this.state.EquipmentServiceID, ...arrItems]
                        }, () => {
                            console.log("result", this.state.EquipmentServiceID)
                        })
                    }
                    if (this.state.equipmentinfo?.equipment.toLowerCase().includes("lifeboat")) {
                        let ShipId = this.state.AddServiceYear[0].shipId;
                        let EquipId = this.state.AddServiceYear[0].equipmentId;
                        let MakeId = parseInt(this.state.equipmentinfo.lifeboatMakeId);
                        let ModelId = parseInt(this.state.equipmentinfo.lifeboatModelId);
                        let DavitwinchMakeId = parseInt(this.state.equipmentinfo.davitwinchMakeId);
                        let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${EquipId}&makeId=${MakeId}&modelId=${ModelId}&davitWinchMakeId=${DavitwinchMakeId}`;
                        axios
                            .get(url)
                            .then((response) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListSuccess",
                                    data: response.data,
                                });
                                if (response.data) {
                                    response.data.map((f, index) => {
                                        let interval = f.interval;
                                        let type = f.serviceType.replace(/ +/g, "");
                                        this.state.interval = f.interval;
                                        this.state["lastDoneDate" + type] = this.state["lastDoneDate" + type] ? this.state["lastDoneDate" + type] : "";
                                        this.state["nextDueDate" + type] = this.state["nextDueDate" + type] ? this.state["nextDueDate" + type] : "";
                                        this.state["lastannualServiceCertificate" + type] = this.state["lastannualServiceCertificate" + type] ? this.state["lastannualServiceCertificate" + type] : "";
                                        this.state["attachmentName" + type] = this.state["attachmentName" + type];
                                        this.state["attachmentGuid" + type] = this.state["attachmentGuid" + type];
                                        this.state["lastannualServicePhoto" + type] = this.state["lastannualServicePhoto" + type];
                                        this.setState({}, () => { })
                                        let port = {
                                            port: this.state["lastDonePort" + type],
                                            country: this.state["lastDoneCountry" + type],
                                            serviceProvider:
                                                this.state["lastDoneServiceProvider" + type],
                                            type: type,
                                        };

                                        dispatch(getShipPortAndCountry(port));
                                    });
                                }
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListFailure",
                                    data: "error",
                                });
                            });
                    } else if (this.state.equipmentinfo?.equipment.toLowerCase().includes("rescue boat")) {
                        let ShipId = this.state.AddServiceYear[0].shipId;
                        let EquipId = this.state.AddServiceYear[0].equipmentId;
                        let MakeId = parseInt(this.state.equipmentinfo.rescueboatMakeId);
                        let ModelId = parseInt(this.state.equipmentinfo.rescueboatModelId);
                        let DavitwinchMakeId = parseInt(this.state.equipmentinfo.rescueboatdavitwinchMakeId);
                        let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${EquipId}&makeId=${MakeId}&modelId=${ModelId}&davitWinchMakeId=${DavitwinchMakeId}`;
                        axios
                            .get(url)
                            .then((response) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListSuccess",
                                    data: response.data,
                                });
                                if (response.data) {
                                    response.data.map((f, index) => {
                                        let interval = f.interval;
                                        let type = f.serviceType.replace(/ +/g, "");
                                        this.state.interval = f.interval;
                                        this.state["lastDoneDate" + type] = this.state["lastDoneDate" + type] ? this.state["lastDoneDate" + type] : "";
                                        this.state["nextDueDate" + type] = this.state["nextDueDate" + type] ? this.state["nextDueDate" + type] : "";
                                        this.state["lastannualServiceCertificate" + type] = this.state["lastannualServiceCertificate" + type] ? this.state["lastannualServiceCertificate" + type] : "";
                                        this.state["attachmentName" + type] = this.state["attachmentName" + type];
                                        this.state["attachmentGuid" + type] = this.state["attachmentGuid" + type];
                                        this.state["lastannualServicePhoto" + type] = this.state["lastannualServicePhoto" + type];
                                        this.setState({}, () => { })
                                        let port = {
                                            port: this.state["lastDonePort" + type],
                                            country: this.state["lastDoneCountry" + type],
                                            serviceProvider:
                                                this.state["lastDoneServiceProvider" + type],
                                            type: type,
                                        };
                                        dispatch(getShipPortAndCountry(port));
                                    });
                                }
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListFailure",
                                    data: "error",
                                });
                            });
                    } else {
                        let ShipId = this.state.AddServiceYear[0].shipId;
                        let EquipId = this.state.AddServiceYear[0].equipmentId;
                        let MakeId = parseInt(this.state.equipmentinfo.makeId);
                        let ModelId = parseInt(this.state.equipmentinfo.modelId);
                        let url = `${API.ServiceTypeInterval}?shipid=${ShipId}&equipmentId=${EquipId}&makeId=${MakeId ?? 0}&modelId=${ModelId ?? 0
                            }`;
                        axios
                            .get(url)
                            .then((response) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListSuccess",
                                    data: response.data,
                                });
                                if (response.data) {
                                    response.data.map((f, index) => {
                                        let interval = f.interval;
                                        let type = f.serviceType.replace(/ +/g, "");
                                        this.state.interval = f.interval;
                                        this.state["lastDoneDate" + type] = this.state["lastDoneDate" + type] ? this.state["lastDoneDate" + type] : "";
                                        this.state["nextDueDate" + type] = this.state["nextDueDate" + type] ? this.state["nextDueDate" + type] : "";
                                        this.state["lastannualServiceCertificate" + type] = this.state["lastannualServiceCertificate" + type] ? this.state["lastannualServiceCertificate" + type] : "";
                                        this.state["attachmentName" + type] = this.state["attachmentName" + type];
                                        this.state["attachmentGuid" + type] = this.state["attachmentGuid" + type];
                                        this.state["lastannualServicePhoto" + type] = this.state["lastannualServicePhoto" + type];
                                        this.setState({}, () => { })
                                        let port = {
                                            port: this.state["lastDonePort" + type],
                                            country: this.state["lastDoneCountry" + type],
                                            serviceProvider:
                                                this.state["lastDoneServiceProvider" + type],
                                            type: type,
                                        };
                                        dispatch(getShipPortAndCountry(port));
                                    });
                                }
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "getServiceTypeIntervalListFailure",
                                    data: "error",
                                });
                            });
                    }
                    this.setState({ modalIsOpen: false, openAlert: false }, () => {
                        this.ClearServiceYear();
                    });
                    toast.success(`${t("CommonText.CommonAdd")}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    /*  swal("Success!", "O", "success"); */
                }
            })
            .catch((error) => {
                // swal("Error!", "Something went wrong. Please try again.", "warning");
                swal({
                    title: t('SwalError.ErrorTitle'),
                    text: t('CommonText.500ErrorMessage'),
                    icon: 'warning',
                    buttons: {
                        confirm: {
                            text: t('confirmAlertMessage.Ok')
                        }
                    }
                });
                if (error?.response?.status === 401) {
                }
            });
    };

    handleSelectChange(value, field, id, item) {
        const { dispatch, EquipmentDropDownList, match, t, editEquipment } = this.props;
        if (field === "equipment") {
            if (!editEquipment && this.isDuplicateShipEquipment(value)) {
                this.showDuplicateEquipmentWarning(t);
                this.state.openEquipment = false;
                this.setState({});
                return;
            }
            $("#categoryErrMsg").text('')
            $("#equipmenttypeErrMsg").text('')
            $("#capacityErrMsg").text('')
            $("#typeErrMsg").text('')
            this.state.dropDown.EquipmentName = value;
            this.state.dropDown.Category = "";
            this.state.dropDown.EquipmentType = "";
            this.state.dropDown.Capacity = "";
            this.state.dropDown.makeId = 0;
            this.state.dropDown.davitwinchMakeId = 0;
            this.state.equipmentinfo.equipmentId = id;
            this.state.equipmentinfo.serviceDetails = [];
            this.state.equipmentinfo.capacity = "";
            this.state.equipmentinfo.category = "";
            this.state.equipmentinfo.equipmentType = "";
            this.state.equipmentinfo.makeId = 0;
            this.state.equipmentinfo.make = "";
            this.state.equipmentinfo.model = "";
            this.state.equipmentinfo.modelId = 0;
            this.state.equipmentinfo.lifeboatMake = "";
            this.state.equipmentinfo.lifeboatMakeId = 0;
            this.state.equipmentinfo.lifeboatModel = "";
            this.state.equipmentinfo.lifeboatModelId = 0;
            this.state.equipmentinfo.davitwinchMake = "";
            this.state.equipmentinfo.davitwinchMakeId = 0;
            this.state.equipmentinfo.rescueboatMake = "";
            this.state.equipmentinfo.rescueboatMakeId = 0;
            this.state.equipmentinfo.rescueboatModel = "";
            this.state.equipmentinfo.rescueboatModelId = 0;
            this.state.equipmentinfo.rescueboatdavitwinchMake = "";
            this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
            this.state.equipmentinfo.equipmentContractTypeId = item?.equipmentContractTypeId ? item?.equipmentContractTypeId : 0;
            const equipContractObj = this.state.equipemntConfigTypeList?.filter(r => r.lookUpId == item?.equipmentContractTypeId)[0];
            this.state.selectedEquipmentTypes = equipContractObj ? equipContractObj : [];
            // let url = `${API.ServiceTypeInterval}?equipmentId=${id}`;
            // axios
            //   .get(url)
            //   .then((response) => {
            //     if (response.data) {
            //       response.data.map((f, index) => {

            //         let interval = f.interval;
            //         let type = f.serviceType.replace(/ +/g, "");
            //         this.state.interval = f.interval;
            //         let port = {
            //           port: this.state["lastDonePort" + type],
            //           country: this.state["lastDoneCountry" + type],
            //           serviceProvider: this.state["lastDoneServiceProvider" + type],
            //           type: type,
            //         };
            //         dispatch(getShipPortAndCountry(port));
            //       });
            //     }

            //     dispatch({
            //       type: "getServiceTypeIntervalListSuccess",
            //       data: response.data,
            //     });
            //   })
            //   .catch((error) => {
            //     dispatch({
            //       type: "getServiceTypeIntervalListFailure",
            //       data: "error",
            //     });
            //   });
            console.log(this.state.dropDown,'testviza')
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        }
        this.state.equipmentinfo[field] = value;
        this.setState({}, () => {

            if (
                this.state?.equipmentinfo?.equipment.toLowerCase().includes("lifeboat")
            ) {
                let equipId = id;
                this.state.AddServiceYear[0].equipmentId = equipId;
                this.setState({})
                var ShipId = parseInt(match.params.id);
                let makeId = 0;
                let modelId = 0;
                let davitwinchMakeId = 0;
                $("#ModelHide").addClass("none");
                $("#MakeHide").addClass("none");
                $("#rescueboatEquipment").addClass("lifeBoat-hide");
                $("#rescueboatEquipment1").addClass("lifeBoat-hide");
                $("#rescueboatEquipment2").addClass("lifeBoat-hide");
                $("#rescueboatEquipment3").addClass("lifeBoat-hide");
                $("#categoryequiptype").addClass("categorylifeboat");
                $("#LifeBoatEquipment").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment1").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment2").removeClass("lifeBoat-hide");
                $("#LifeBoatEquipment3").removeClass("lifeBoat-hide");
                /*   let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${equipId}&makeId=${makeId??0}&modelId=${modelId??0}&davitWinchMakeId=${davitwinchMakeId??0}`;
                  axios
                    .get(url)
                    .then((response) => {
                      dispatch({
                        type: "getServiceTypeIntervalListSuccess",
                        data: response.data,
                      });
                      this.setState({ openOwnerRequirement: true });
                      if (response.data) {
                        response.data.map((f, index) => {
                          let interval = f.interval;
                          let type = f.serviceType.replace(/ +/g, "");
                          this.state.interval = f.interval;
                          let port = {
                            port: this.state["lastDonePort" + type],
                            country: this.state["lastDoneCountry" + type],
                            serviceProvider: this.state["lastDoneServiceProvider" + type],
                            type: type,
                          };
                          dispatch(getShipPortAndCountry(port));
                        });
                      }
                    })
                    .catch((error) => {
                      dispatch({
                        type: "getServiceTypeIntervalListFailure",
                        data: "error",
                      });
                    }); */
            }
            else if (this.state.equipmentinfo?.equipment
                .toLowerCase()
                .includes("rescue boat")) {
                let equipId = id;
                this.state.AddServiceYear[0].equipmentId = equipId;
                this.setState({})
                var ShipId = parseInt(match.params.id);
                let makeId = 0;
                let modelId = 0;
                let davitWinchMakeId = 0;
                $("#ModelHide").addClass("none");
                $("#MakeHide").addClass("none");
                $("#categoryequiptype").removeClass("categorylifeboat");
                $("#LifeBoatEquipment").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
                $("#rescueboatEquipment").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment1").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment2").removeClass("lifeBoat-hide");
                $("#rescueboatEquipment3").removeClass("lifeBoat-hide");
                /*  let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${equipId}&makeId=${makeId??0}&modelId=${modelId??0}&davitWinchMakeId=${davitWinchMakeId??0}`;
                 axios
                   .get(url)
                   .then((response) => {
                     dispatch({
                       type: "getServiceTypeIntervalListSuccess",
                       data: response.data,
                     });
                     this.setState({ openOwnerRequirement: true });
                     if (response.data) {
                       response.data.map((f, index) => {
                         let interval = f.interval;
                         let type = f.serviceType.replace(/ +/g, "");
                         this.state.interval = f.interval;
                         let port = {
                           port: this.state["lastDonePort" + type],
                           country: this.state["lastDoneCountry" + type],
                           serviceProvider: this.state["lastDoneServiceProvider" + type],
                           type: type,
                         };
                         dispatch(getShipPortAndCountry(port));
                       });
                     }
                   })
                   .catch((error) => {
                     dispatch({
                       type: "getServiceTypeIntervalListFailure",
                       data: "error",
                     });
                   }); */
            }

            else {
                $("#ModelHide").removeClass("none");
                $("#MakeHide").removeClass("none");
                $("#categoryequiptype").removeClass("categorylifeboat");
                $("#LifeBoatEquipment").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
                $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
                $("#rescueboatEquipment").addClass("lifeBoat-hide");
                $("#rescueboatEquipment1").addClass("lifeBoat-hide");
                $("#rescueboatEquipment2").addClass("lifeBoat-hide");
                $("#rescueboatEquipment3").addClass("lifeBoat-hide");
            }

        });
    }

    handleInputChange(e) {
        const { dispatch, EquipmentDropDownList } = this.props;
        let nodeName = e.target.name;

        // if (nodeName === "equipment") {
        //     this.state.dropDown.EquipmentName = e.target.value;
        //     this.state.equipmentinfo.capacity = "";
        //     this.state.equipmentinfo.category = "";
        //     this.state.equipmentinfo.equipmentType = "";
        //     dispatch(getApplicableServiceTypeList(e.target.value));
        //     dispatch(getEquipmentDropDownList(this.state.dropDown));
        // }
        if (nodeName === "equipment") {
            this.state.dropDown.EquipmentName = e.target.value;
            this.state.dropDown.Category = "";
            this.state.dropDown.EquipmentType = "";
            this.state.equipmentinfo.serviceDetails = [];
            this.state.equipmentinfo.capacity = "";
            this.state.equipmentinfo.category = "";
            this.state.equipmentinfo.equipmentType = "";

            let url = `${API.ServiceTypeInterval}?EquipmentName=${e.target.value}`;
            axios
                .get(url)
                .then((response) => {
                    if (response.data) {
                        response.data.map((f, index) => {
                            let interval = f.interval;
                            let type = f.serviceType?.replace(/ +/g, "");
                            this.state.interval = f.interval;
                            let port = {
                                port: this.state["lastDonePort" + type],
                                country: this.state["lastDoneCountry" + type],
                                serviceProvider: this.state["lastDoneServiceProvider" + type],
                                type: type,
                            };
                            //dispatch(
                            // getServiceDates(
                            //    Moment(new Date()).format("YYYY-MM-DD"),
                            //   interval,
                            //   type
                            // )
                            //);
                            dispatch(getShipPortAndCountry(port));
                        });
                    }

                    dispatch({
                        type: "getServiceTypeIntervalListSuccess",
                        data: response.data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: "getServiceTypeIntervalListFailure",
                        data: "error",
                    });
                });
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            // dispatch(getApplicableServiceTypeListWithInterval(e.target.value));
            // dispatch(getEquipmentDropDownList(this.state.dropDown));
            // dispatch(getServiceDates(this.state.serviceDate,this.state.interval));
        }
        if (nodeName === "category") {
            this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
            this.state.dropDown.Category = e.target.value;
            this.state.dropDown.EquipmentType = "";
            this.state.equipmentinfo.serviceDetails = [];
            this.state.equipmentinfo.capacity = "";
            this.state.equipmentinfo.category = "";
            this.state.equipmentinfo.equipmentType = "";
            // dispatch(getApplicableServiceTypeList(e.target.value));
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        }

        if (nodeName === "capacity") {
            this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
            this.state.dropDown.Category = this.state.dropDown.Category;
            this.state.dropDown.EquipmentType = this.state.dropDown.EquipmentType;
            this.state.dropDown.Capacity = e.target.value;
            this.state.equipmentinfo.capacity = e.target.value;
            /*  let item = EquipmentDropDownList.find((o) => o.capacity === value);
            let equipId = item.equipmentId;
      
            let url = `${API.ServiceTypeInterval}?equipmentId=${equipId}`;
            axios
              .get(url)
              .then((response) => {
                dispatch({
                  type: "getServiceTypeIntervalListSuccess",
                  data: response.data,
                });
                this.setState({ openOwnerRequirement: true });
                if (response.data) {
                  response.data.map((f, index) => {
                    let interval = f.interval;
                    let type = f.serviceType?.replace(/ +/g, "");
                    this.state.interval = f.interval;
                    let port = {
                      port: this.state["lastDonePort" + type],
                      country: this.state["lastDoneCountry" + type],
                      serviceProvider: this.state["lastDoneServiceProvider" + type],
                      type: type,
                    };
                    dispatch(getShipPortAndCountry(port));
                  });
                }
              })
              .catch((error) => {
                dispatch({
                  type: "getServiceTypeIntervalListFailure",
                  data: "error",
                });
              }); */
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        }
        /*  if(nodeName=== "modelId"){
          this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
          this.state.dropDown.Category = this.state.dropDown.Category;
          this.state.dropDown.EquipmentType =this.state.dropDown.EquipmentType;
          this.state.dropDown.Capacity = this.state.dropDown.Capacity;
          this.state.dropDown.Model=e.target.value;
          let value=e.target.value;
          let item = EquipmentDropDownList.find((o) => o.capacity === value);
          let equipId = item.equipmentId;
    
          let url = `${API.ServiceTypeInterval}?equipmentId=${equipId}`;
          axios
            .get(url)
            .then((response) => {
              dispatch({
                type: "getServiceTypeIntervalListSuccess",
                data: response.data,
              });
              this.setState({ openOwnerRequirement: true });
              if (response.data) {
                response.data.map((f, index) => {
                  let interval = f.interval;
                  let type = f.serviceType?.replace(/ +/g, "");
                  this.state.interval = f.interval;
                  let port = {
                    port: this.state["lastDonePort" + type],
                    country: this.state["lastDoneCountry" + type],
                    serviceProvider: this.state["lastDoneServiceProvider" + type],
                    type: type,
                  };
                  dispatch(getShipPortAndCountry(port));
                });
              }
            })
            .catch((error) => {
              dispatch({
                type: "getServiceTypeIntervalListFailure",
                data: "error",
              });
            });
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        } */
        if (nodeName == "equipmentTypeid") {
            // this.state.equipmentinfo.equipmentTypeid = parseInt(e.target.value);
        }
        else {
            this.state.equipmentinfo[nodeName] = e.target.value;
        }
        this.setState({});
    }
    handleMakeSearchChanges(e, field) {
        this.state.make = e.target.value;
        this.state.equipmentinfo.make = e.target.value;
        this.setState({});
    }
    handleModelSearchChanges(e, field) {
        this.state.equipmentinfo.model = e.target.value;
        this.setState({});
    }
    handleEquipmentTypeSearchChanges(e, field) {
        const { dispatch } = this.props;
        this.state.equipmentinfo.equipmentType = e.target.value;
        this.setState({})
        if (e.target.value === "") {
            if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
                this.state.equipmentinfo.lifeboatMake = "";
                this.state.equipmentinfo.lifeboatMake = "";
                this.state.equipmentinfo.lifeboatModel = "";
                this.state.equipmentinfo.davitwinchMake = "";
                this.state.equipmentinfo.lifeboatMakeId = 0;
                this.state.equipmentinfo.lifeboatModelId = 0;
                this.state.equipmentinfo.davitwinchMakeId = 0;
            } else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {
                this.state.equipmentinfo.rescueboatMake = "";
                this.state.equipmentinfo.rescueboatModel = "";
                this.state.equipmentinfo.rescueboatdavitwinchMake = "";
                this.state.equipmentinfo.rescueboatMakeId = 0;
                this.state.equipmentinfo.rescueboatModelId = 0;
                this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
            } else {
                this.state.equipmentinfo.make = "";
                this.state.equipmentinfo.makeId = 0;
                this.state.equipmentinfo.model = "";
                this.state.equipmentinfo.modelId = 0;
            }
            this.state.dropDown.EquipmentType = "";
            this.setState({})
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        }
    }
    handleModelSelectChange(value, field, id) {
        const { dispatch, EquipmentDropDownList, match } = this.props;
        var ShipId = parseInt(match.params.id);
        if (field === "modelId") {
            let result = this.state.equipmentinfo.equipment;
            let item = EquipmentDropDownList?.find((o) => o.equipmentName === result);
            let equipId = item?.equipmentId || 0;
            this.state.equipmentinfo.model = value;
            this.state.equipmentinfo.modelId = id;
            this.state.AddServiceYear[0].equipmentId = equipId;
            this.setState({});
            let modelId = id;
            let makeId = this.state.equipmentinfo.makeId;
            if (equipId) {
                let url = `${API.ServiceTypeInterval
                    }?shipid=${ShipId}&equipmentId=${equipId}&makeId=${makeId ?? 0}&modelId=${modelId ?? 0
                    }`;
                axios
                    .get(url)
                    .then((response) => {
                        dispatch({
                            type: "getServiceTypeIntervalListSuccess",
                            data: response.data,
                        });
                        response.data.forEach((_, index) => {
                            if (this.props.editEquipment == true) {
                                if (this.state.applicableServiceEquipType[index]) {
                                    this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: 0, lookUpName: '' };
                                } else {
                                    // Initialize an object if it doesn't exist at the current index
                                    this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: 0, lookUpName: '' } };
                                }
                            }
                            else {
                                if (this.state.applicableServiceEquipType[index]) {
                                    this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName };
                                    this.state.applicableServiceEquipType[index].serviceType = _.serviceType;
                                    this.state.applicableServiceEquipType[index].applicableEquipType.serviceTypeId = _.serviceTypeId;
                                } else {
                                    // Initialize an object if it doesn't exist at the current index
                                    this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: this.state.selectedEquipmentTypes.lookUpId, lookUpName: this.state.selectedEquipmentTypes.lookUpName }, serviceType: _.serviceType, serviceTypeId: _.serviceTypeId };
                                }
                            }
                        });
                        this.setState({ openOwnerRequirement: true });
                        if (response.data) {
                            response.data.map((f, index) => {
                                let interval = f.interval;
                                let type = f.serviceType.replace(/ +/g, "");
                                this.state.interval = f.interval;
                                let port = {
                                    port: this.state["lastDonePort" + type],
                                    country: this.state["lastDoneCountry" + type],
                                    serviceProvider: this.state["lastDoneServiceProvider" + type],
                                    type: type,
                                };
                                dispatch(getShipPortAndCountry(port));
                            });
                        }
                    })
                    .catch((error) => {
                        dispatch({
                            type: "getServiceTypeIntervalListFailure",
                            data: "error",
                        });
                    });
            }
        }
    }
    handleMakeSelectChange(value, field, id) {
        const { dispatch } = this.props;
        if (field === "makeId") {
            this.state.dropDown.makeId = id;
            if (value === "others") {
                dispatch(getModelsOtherList(value))
                this.state.modelOthers = true;
                this.setState({})
            } else {
                this.state.modelOthers = false;
                this.setState({})
            }
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            dispatch(getModelsList(value));
            this.state.equipmentinfo.make = value;
            this.state.equipmentinfo.makeId = id;
            this.state.equipmentinfo.model = "";
            this.state.equipmentinfo.modelId = 0;
            this.setState({});
        }
    }
    handleEquipmentTypeSelectChange(value, field, id) {
        const { dispatch } = this.props;
        if (field === "equipmentType") {
            this.state.dropDown.EquipmentName = this.state.dropDown.EquipmentName;
            this.state.dropDown.Category = this.state.dropDown.Category;
            this.state.dropDown.EquipmentType = value;
            this.state.equipmentinfo.serviceDetails = [];
            this.state.equipmentinfo.capacity = "";
            this.state.equipmentinfo.category = this.state.dropDown.Category;
            this.state.equipmentinfo.equipmentType = value;
            if (this.state.equipmentinfo.equipment.toLowerCase().includes("lifeboat")) {
                this.state.equipmentinfo.lifeboatMake = "";
                this.state.equipmentinfo.lifeboatMake = "";
                this.state.equipmentinfo.lifeboatModel = "";
                this.state.equipmentinfo.davitwinchMake = "";
                this.state.equipmentinfo.lifeboatMakeId = 0;
                this.state.equipmentinfo.lifeboatModelId = 0;
                this.state.equipmentinfo.davitwinchMakeId = 0;
            } else if (this.state.equipmentinfo.equipment.toLowerCase().includes("rescue boat")) {
                this.state.equipmentinfo.rescueboatMake = "";
                this.state.equipmentinfo.rescueboatModel = "";
                this.state.equipmentinfo.rescueboatdavitwinchMake = "";
                this.state.equipmentinfo.rescueboatMakeId = 0;
                this.state.equipmentinfo.rescueboatModelId = 0;
                this.state.equipmentinfo.rescueboatdavitwinchMakeId = 0;
            } else {
                this.state.equipmentinfo.make = "";
                this.state.equipmentinfo.makeId = 0;
                this.state.equipmentinfo.model = "";
                this.state.equipmentinfo.modelId = 0;
            }
            this.setState({})
            dispatch(getEquipmentDropDownList(this.state.dropDown));
        }


    }
    handleLifeBoatMakeSearchChanges(e, field) {
        if (field === "lifeboatMakeId") {
            this.state.equipmentinfo.lifeboatMake = e.target.value;
            this.setState({});
        } else {
            this.state.equipmentinfo.davitwinchMake = e.target.value;
            this.setState({});
        }
    }
    handleLifeBoatMakeSelectChange(value, field, id) {
        const { dispatch } = this.props;
        if (field === "lifeboatMakeId") {
            this.state.dropDown.makeId = id;
            if (value === "others") {
                dispatch(getModelsOtherList(value))
                this.state.modelOthers = true;
                this.setState({})
            } else {
                this.state.modelOthers = false;
                this.setState({})
            }
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            this.state.equipmentinfo.lifeboatMake = value;
            this.state.equipmentinfo.lifeboatMakeId = id;
            this.state.equipmentinfo.lifeboatModel = "";
            this.state.equipmentinfo.lifeboatModelId = 0;
            this.setState({});
        }
        else if (field === "davitwinchMakeId") {
            this.state.dropDown.davitwinchMakeId = id;
            if (value === "others") {
                dispatch(getModelsOtherList(value))
                this.state.modelOthers = true;
                this.setState({})
            } else {
                this.state.modelOthers = false;
                this.setState({})
            }
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            this.state.equipmentinfo.davitwinchMake = value;
            this.state.equipmentinfo.davitwinchMakeId = id;
            this.state.equipmentinfo.lifeboatModel = "";
            this.state.equipmentinfo.lifeboatModelId = 0;
            this.setState({});
        }
    }

    handleLifeBoatModelSearchChanges(e, field) {
        this.state.equipmentinfo.lifeboatModel = e.target.value;
        this.setState({})

    }
    handleLifeBoatModelSelectChange(value, field, id) {
        const { dispatch, EquipmentDropDownList, match } = this.props;
        var ShipId = parseInt(match.params.id);
        if (field === "lifeboatModelId") {
            let result = this.state.equipmentinfo.equipment;
            let item = EquipmentDropDownList.find((o) => o.equipmentName === result);
            let equipId = item.equipmentId;
            this.state.equipmentinfo.lifeboatModel = value;
            this.state.equipmentinfo.lifeboatModelId = id;
            this.state.AddServiceYear[0].equipmentId = equipId;
            this.setState({});
            let modelId = id;
            let makeId = this.state.equipmentinfo.lifeboatMakeId;
            let davitwinchMakeId = this.state.equipmentinfo.davitwinchMakeId;
            let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${equipId}&makeId=${makeId ?? 0}&modelId=${modelId ?? 0}&davitWinchMakeId=${davitwinchMakeId ?? 0}`;
            axios
                .get(url)
                .then((response) => {
                    dispatch({
                        type: "getServiceTypeIntervalListSuccess",
                        data: response.data,
                    });
                    response.data.forEach((_, index) => {
                        if (this.state.applicableServiceEquipType[index]) {
                            this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: 0, lookUpName: '' };
                        } else {
                            // Initialize an object if it doesn't exist at the current index
                            this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: 0, lookUpName: '' } };
                        }
                    });
                    this.setState({ openOwnerRequirement: true });
                    if (response.data) {
                        response.data.map((f, index) => {
                            let interval = f.interval;
                            let type = f.serviceType.replace(/ +/g, "");
                            this.state.interval = f.interval;
                            let port = {
                                port: this.state["lastDonePort" + type],
                                country: this.state["lastDoneCountry" + type],
                                serviceProvider: this.state["lastDoneServiceProvider" + type],
                                type: type,
                            };
                            dispatch(getShipPortAndCountry(port));
                        });
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: "getServiceTypeIntervalListFailure",
                        data: "error",
                    });
                });
        }
    }


    handleRescueBoatMakeSearchChanges(e, field) {
        if (field === "rescueboatMakeId") {
            this.state.equipmentinfo.rescueboatMake = e.target.value;
            this.setState({});
        } else {
            this.state.equipmentinfo.rescueboatdavitwinchMake = e.target.value;
            this.setState({});
        }
    }
    handleRescueBoatMakeSelectChange(value, field, id) {
        const { dispatch } = this.props;
        if (field === "rescueboatMakeId") {
            this.state.dropDown.makeId = id;
            if (value === "others") {
                dispatch(getModelsOtherList(value))
                this.state.modelOthers = true;
                this.setState({})
            } else {
                this.state.modelOthers = false;
                this.setState({})
            }
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            dispatch(getModelsList(value));
            this.state.equipmentinfo.rescueboatMake = value;
            this.state.equipmentinfo.rescueboatMakeId = id;
            this.state.equipmentinfo.rescueboatModel = "";
            this.state.equipmentinfo.rescueboatModelId = 0;
            this.setState({});
        }
        else if (field === "rescueboatdavitwinchMakeId") {
            this.state.dropDown.davitwinchMakeId = id;
            if (value === "others") {
                dispatch(getModelsOtherList(value))
                this.state.modelOthers = true;
                this.setState({})
            } else {
                this.state.modelOthers = false;
                this.setState({})
            }
            dispatch(getEquipmentDropDownList(this.state.dropDown));
            dispatch(getModelsList(value));
            this.state.equipmentinfo.rescueboatdavitwinchMake = value;
            this.state.equipmentinfo.rescueboatdavitwinchMakeId = id;
            this.state.equipmentinfo.rescueboatModel = "";
            this.state.equipmentinfo.rescueboatModelId = 0;
            this.setState({});
        }
    }

    handleRescueBoatModelSearchChanges(e, field) {
        this.state.equipmentinfo.rescueboatModel = e.target.value;
        this.setState({})
    }
    handleRescueBoatModelSelectChange(value, field, id) {
        const { dispatch, EquipmentDropDownList, match } = this.props;
        var ShipId = parseInt(match.params.id);
        if (field === "rescueboatModelId") {
            let result = this.state.equipmentinfo.equipment;
            let item = EquipmentDropDownList.find((o) => o.equipmentName === result);
            let equipId = item.equipmentId;

            this.state.equipmentinfo.rescueboatModel = value;
            this.state.equipmentinfo.rescueboatModelId = id;
            this.state.AddServiceYear[0].equipmentId = equipId;
            this.setState({});
            let modelId = id;
            let makeId = this.state.equipmentinfo.rescueboatMakeId;
            let davitwinchMakeId = this.state.equipmentinfo.rescueboatdavitwinchMakeId;
            let url = `${API.EquipmentServiceIntervalList}?shipid=${ShipId}&equipmentId=${equipId}&makeId=${makeId ?? 0}&modelId=${modelId ?? 0}&davitWinchMakeId=${davitwinchMakeId ?? 0}`;
            axios
                .get(url)
                .then((response) => {
                    dispatch({
                        type: "getServiceTypeIntervalListSuccess",
                        data: response.data,
                    });
                    response.data.forEach((_, index) => {
                        if (this.state.applicableServiceEquipType[index]) {
                            this.state.applicableServiceEquipType[index].applicableEquipType = { lookUpId: 0, lookUpName: '' };
                        } else {
                            // Initialize an object if it doesn't exist at the current index
                            this.state.applicableServiceEquipType[index] = { applicableEquipType: { lookUpId: 0, lookUpName: '' } };
                        }
                    });
                    this.setState({ openOwnerRequirement: true });
                    if (response.data) {
                        response.data.map((f, index) => {
                            let interval = f.interval;
                            let type = f.serviceType.replace(/ +/g, "");
                            this.state.interval = f.interval;
                            let port = {
                                port: this.state["lastDonePort" + type],
                                country: this.state["lastDoneCountry" + type],
                                serviceProvider: this.state["lastDoneServiceProvider" + type],
                                type: type,
                            };
                            dispatch(getShipPortAndCountry(port));
                        });
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: "getServiceTypeIntervalListFailure",
                        data: "error",
                    });
                });
        }
    }


    handleManufacturingDate(date) {
        this.state.equipmentinfo.manufracturingDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            DatePickerIsOpen: false,
        });
    }
    openDatePicker() {
        this.setState({
            DatePickerIsOpen: !this.state.DatePickerIsOpen,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    // Annual service info
    handleAnnualInputChange(e, index) {
        const { dispatch, t } = this.props;
        let nodeName = e.target.name;
        if (nodeName === "lastannualServiceCertificate") {
            dispatch(postAnnualCertificate(e.target.files[0], index));
            this.setState({
                ["lastannualServiceCertificate" + index]: e.target.files[0].name,
                ["file" + index]: e.target.files[0],
            });
        } else {
            var fieldname = nodeName + index;
            this.state[fieldname] = e.target.value;
            this.setState({});
            // this.setState({
            //     [""+fieldname]:e.target.value
            // })
        }
    }
    handleServiceDateChange(value, field, intervalValue, serviceTypeId) {
        const { t } = this.props;
        let date1 = Moment(new Date(Date.parse(value))).format("YYYY-MM-DD");
        this.setState({
            ["lastDoneDate" + field]: date1,
            ["lastannualDatePickerIsOpen" + field]: false,
        });
        if (this.state.equipmentinfo.shipEquipmentId !== 0) {
            if (date1 !== "") {
                let url1 = `${API.ServiceDateExist}?shipEquipmentId=${this.state.equipmentinfo.shipEquipmentId}&serviceTypeId=${serviceTypeId}&serviceDate=${date1}`;
                axios
                    .get(url1)
                    .then((response) => {
                        if (response.data === true) {
                            this.props.dispatch(getServiceDates(date1, intervalValue, field));
                        } else {
                            // swal("Error!", "The service is already updated for this date. Please choose another date.", "warning");
                            swal({
                                title: t('SwalError.ErrorTitle'),
                                text: t('CommonText.ServiceChose'),
                                icon: 'warning',
                                buttons: {
                                    confirm: {
                                        text: t('confirmAlertMessage.Ok')
                                    }
                                }
                            });
                        }
                        this.props.dispatch({
                            type: "ExistservicedateSuccess",
                            data: response.data,
                        })
                    })
                    .catch((error) => {
                        this.props.dispatch({
                            type: "ExistservicedateFailure",
                            error: "ERROR"
                        })
                    })

            }
        } else {
            this.props.dispatch(getServiceDates(date1, intervalValue, field));
        }
    }
    handlenextServiceDateChange(value, field) {
        let date1 = Moment(new Date(Date.parse(value))).format("YYYY-MM-DD");
        this.setState({
            ["nextDueDate" + field]: date1,
            ["nextannualDatePickerIsOpen" + field]: false,
        });
    }
    openannualDatePicker(field) {
        this.setState({
            ["lastannualDatePickerIsOpen" + field]:
                !this.state["lastannualDatePickerIsOpen" + field],
            ["nextannualDatePickerIsOpen" + field]: false,
        });
    }
    DatePickerOnBlur(field) {
        this.setState({
            ["lastannualDatePickerIsOpen" + field]: false,
            ["nextannualDatePickerIsOpen" + field]: false,
        });
    }
    handleAnnualServiceDate(date) {
        this.state.Annual.lastDoneDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            lastannualDatePickerIsOpen: false,
        });
    }
    // openannualDatePicker() {
    //     this.setState({
    //         lastannualDatePickerIsOpen: !this.state.lastannualDatePickerIsOpen,
    //         DatePickerIsOpen: false,
    //         nextannualDatePickerIsOpen: false,
    //         lastbiannualDatePickerIsOpen: false,
    //         nextbiannualDatePickerIsOpen: false,
    //         lastFiveYearDatePickerIsOpen: false,
    //         nextFiveYearDatePickerIsOpen: false,
    //         lastTenYearDatePickerIsOpen: false,
    //         nextTenYearDatePickerIsOpen: false,
    //     });
    // }
    handlenextAnnualServiceDate(date) {
        this.state.Annual.nextDueDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            nextannualDatePickerIsOpen: false,
        });
    }
    nextannualDatePicker(field) {
        this.setState({
            ["nextannualDatePickerIsOpen" + field]:
                !this.state["nextannualDatePickerIsOpen" + field],
            ["lastannualDatePickerIsOpen" + field]: false,
        });
    }
    // nextannualDatePicker() {
    //     this.setState({
    //         nextannualDatePickerIsOpen: !this.state.nextannualDatePickerIsOpen,
    //         DatePickerIsOpen: false,
    //         lastannualDatePickerIsOpen: false,
    //         lastbiannualDatePickerIsOpen: false,
    //         nextbiannualDatePickerIsOpen: false,
    //         lastFiveYearDatePickerIsOpen: false,
    //         nextFiveYearDatePickerIsOpen: false,
    //         lastTenYearDatePickerIsOpen: false,
    //         nextTenYearDatePickerIsOpen: false,
    //     });
    // }
    // Biannual service info
    handleBiannualInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "lastbiannualServiceCertificate") {
            this.setState({
                lastbiannualServiceCertificate: e.target.files[0].name,
                file2: e.target.files[0],
            });
        } else {
            this.state.Biannual[nodeName] = e.target.value;
            this.setState({});
        }
    }
    handleBiannualServiceDate(date) {
        this.state.Biannual.lastDoneDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            lastbiannualDatePickerIsOpen: false,
        });
    }
    openbiannualDatePicker() {
        this.setState({
            lastbiannualDatePickerIsOpen: !this.state.lastbiannualDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    handlenextBiannualServiceDate(date) {
        this.state.Biannual.nextDueDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            nextbiannualDatePickerIsOpen: false,
        });
    }
    nextbiannualDatePicker() {
        this.setState({
            nextbiannualDatePickerIsOpen: !this.state.nextbiannualDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    // Five yearly service info
    handleFiveYearlyInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "last5yearlyServiceCertificate") {
            this.setState({
                last5yearlyServiceCertificate: e.target.files[0].name,
                file3: e.target.files[0],
            });
        } else {
            this.state.Fiveyearly[nodeName] = e.target.value;
            this.setState({});
        }
    }
    handle5YearServiceDate(date) {
        this.state.Fiveyearly.lastDoneDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            lastFiveYearDatePickerIsOpen: false,
        });
    }
    open5YearDatePicker() {
        this.setState({
            lastFiveYearDatePickerIsOpen: !this.state.lastFiveYearDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    handlenext5YearServiceDate(date) {
        this.state.Fiveyearly.nextDueDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            nextFiveYearDatePickerIsOpen: false,
        });
    }
    next5YearDatePicker() {
        this.setState({
            nextFiveYearDatePickerIsOpen: !this.state.nextFiveYearDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    // Ten yearly service info
    handleTenYearlyInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "last10yearlyServiceCertificate") {
            this.setState({
                last10yearlyServiceCertificate: e.target.files[0].name,
                file4: e.target.files[0],
            });
        } else {
            this.state.Tenyearly[nodeName] = e.target.value;
            this.setState({});
        }
    }
    handle10YearServiceDate(date) {
        this.state.Tenyearly.lastDoneDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            lastTenYearDatePickerIsOpen: false,
        });
    }
    open10YearDatePicker() {
        this.setState({
            lastTenYearDatePickerIsOpen: !this.state.lastTenYearDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            nextTenYearDatePickerIsOpen: false,
        });
    }
    handlenext10YearServiceDate(date) {
        this.state.Tenyearly.nextDueDate = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            nextTenYearDatePickerIsOpen: false,
        });
    }
    next10YearDatePicker() {
        this.setState({
            nextTenYearDatePickerIsOpen: !this.state.nextTenYearDatePickerIsOpen,
            DatePickerIsOpen: false,
            lastannualDatePickerIsOpen: false,
            nextannualDatePickerIsOpen: false,
            lastbiannualDatePickerIsOpen: false,
            nextbiannualDatePickerIsOpen: false,
            lastFiveYearDatePickerIsOpen: false,
            nextFiveYearDatePickerIsOpen: false,
            lastTenYearDatePickerIsOpen: false,
        });
    }

    handleBlur() {
        this.setState({
            DatePickerIsOpen: false,
        });
    }

    ClearInput(id) {
        // this.props.dispatch(deleteAttachmentInBucket(this.state["attachmentGuid" + id],this.state["attachmentName" + id]));

        let obj = {
            filename: this.state["attachmentName" + id],
            guid: this.state["attachmentGuid" + id],
        }
        fileDatas.push(obj);
        this.state["lastannualServiceCertificate" + id] = "";
        this.state["attachmentName" + id] = "";
        this.state["attachmentGuid" + id] = "";
        this.setState({});
        let sta = this.state;
    }
    // } else if (id === 2) {
    //     this.setState({
    //         lastbiannualServiceCertificate: '',
    //         file2: ''
    //     })
    // } else if (id === 3) {
    //     this.setState({
    //         last5yearlyServiceCertificate: '',
    //         file3: ''
    //     })
    // } else if (id === 4) {
    //     this.setState({
    //         last10yearlyServiceCertificate: '',
    //         file4: ''
    //     })
    // }
    handleAnnualSearchChange(e, index, name) {
        const { dispatch } = this.props;
        let nodeName = name;
        let port = {
            port:
                name === "lastDonePort"
                    ? e.target.value
                    : this.state["lastDonePort" + index],
            country:
                name === "lastDoneCountry"
                    ? e.target.value
                    : this.state["lastDoneCountry" + index],
            serviceProvider:
                name === "lastDoneServiceProvider"
                    ? e.target.value
                    : this.state["lastDoneServiceProvider" + index],
            type: index,
        };
        if (e.target.value === "" && name === "lastDonePort") {
            this.state["lastDonePort" + index] = "";
            this.state["lastDoneCountry" + index] = "";
            this.state["lastDoneServiceProvider" + index] = "";
            this.state["ServiceProviderId" + index] = [];
            this.setState({});
            let portdata = {
                port: "",
                country: "",
                serviceProvider: "",
                type: index,
            };
            this.props.dispatch(getShipPortAndCountry(portdata));
        } else {
            this.props.dispatch(getShipPortAndCountry(port));
        }
        var fieldname = nodeName + index;
        this.state[fieldname] = e.target.value;
        this.setState({});
    }

    handleAnnualSelectChange(e, index, name, id) {
        const { dispatch } = this.props;
        // let port = {};
        let nodeName = name;

        var fieldname = nodeName + index;
        let port = {
            port: name === "lastDonePort" ? e : this.state["lastDonePort" + index],
            country:
                name === "lastDoneCountry" ? e : this.state["lastDoneCountry" + index],
            serviceProvider:
                name === "lastDoneServiceProvider"
                    ? e
                    : this.state["lastDoneServiceProvider" + index],
            type: index,
        };
        // port["lastDoneServiceProvider" + index] = this.state[
        //   "lastDoneServiceProvider" + index
        // ];

        dispatch(getShipPortAndCountry(port));
        this.state[fieldname] = e;
        this.state[nodeName + "id" + index] = id;
        this.setState({});
    }
    renderServiceProviderTitle(state, val) {
        return (
            state?.serviceProvider?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
        );
    }
    renderCountryTitle(state, val) {
        return state?.country?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    }
    renderPortTitle(state, val) {
        return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    }
    confirmChooseFile = (fieldName, e, index) => {
        const { t } = this.props;
        this.setState({ openAlert: true });
        confirmAlert({
            message:
                `${t("confirmAlertMessage.FileuploadMsg")}`,
            buttons: [
                {
                    label: `${t("confirmAlertMessage.Ok")}`,
                    onClick: () => {
                        this.state[fieldName] = this.state[fieldName]
                            ? [...this.state[fieldName], ...e]
                            : [...e];
                        this.setState({ openAlert: false });
                        this.props.dispatch(
                            uploadAttachments(this.state[fieldName], index)
                        );
                    },
                },
                {
                    label: `${t("ComplianceandBudgetScreen.Cancel")}`,
                    onClick: () => {
                        this.setState({ openAlert: false });
                    },
                },
            ],
            onClickOutside: () => {
                this.setState({ openAlert: false });
            },
        });
    };

    handleAnnualInputChangeMultiple(e, index) {
        const { dispatch } = this.props;
        let nodeName = e.target.name;
        var fieldName = nodeName + index;
        // dispatch(postAnnualCertificate(e.target.files[0], index));
        this.confirmChooseFile(fieldName, e.target.files, index);
    }
    onRemoveChange(item, name) {
        this.state[name] = item;
        this.setState({});
    }

    resetServiceDetails = (serviceType) => {
        console.log(this.props.applicableServiceType, 'jip')
        let type = serviceType?.replace(/ +/g, "");
        this.ClearInput(type);
        this.state["lastDoneDate" + type] = "";
        this.state["nextDueDate" + type] = "";
        this.state["lastDonePort" + type] = "";
        this.state["lastDoneCountry" + type] = "";
        this.state["lastDoneServiceProvider" + type] = "";
        this.state["lastannualServiceCertificate" + type] = "";
        this.state["lastannualServicePhoto" + type] = "";
        this.setState({});
    };
    renderMakeTitle(state, val) {
        return state?.name?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
    }
    renderModelTitle(state, val) {
        return state?.name?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
    }
    renderEquipmentTypeTitle(state, val) {
        return state?.toLowerCase().indexOf(val.toLowerCase()) !== -1;
    }
    handleRadioButtonChanges = (e, i) => {
        var lineitems = this.state.AddServiceYear;
        lineitems[i][e.target.name] = e.target.value;
        if (e.target.value === "Shore") {
            lineitems[i]["isShore"] = true;
        }
        if (e.target.value === "Ship") {
            lineitems[i]["isShip"] = true;
        }
        this.setState({ AddServiceYear: lineitems });
    };
    miscChargeValidation() {
        const { t } = this.props;
        let validateField = [];
        let inValidComponent = [];
        let length = this.state.AddServiceYear.length;
        let miscCharges = this.state.AddServiceYear.filter(
            (item) => item.isDeleted === false
        );
        if (
            $("#chargeDescription0").val() === "" ||
            miscCharges[0].radioButton === ""
        ) {
            if ($("#chargeDescription0").val() === "") {
                $("#chargeDescription0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
            } else {
                $("#chargeDescription0ErrMsg").text("");
            }
            if (miscCharges[0].radioButton === "") {
                $("#isUnitPrice0ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
            } else {
                $("#isUnitPrice0ErrMsg").text("");
            }
            return;
        } else {
            $("#chargeDescription0ErrMsg").text("");
            $("#isUnitPrice0ErrMsg").text("");
        }
        let indexFrom =
            $("#chargeDescription0").val() === "" && miscCharges[0].radioButton === ""
                ? 1
                : 0;
        miscCharges.forEach((row, index) => {
            if (index >= indexFrom) {
                validateField.push({ Id: `chargeDescription${index}`, Type: "text" });
                if (row.radioButton === "") {
                    inValidComponent.push(`isUnitPrice${index}`);
                    $("#isUnitPrice" + index + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
                } else {
                    $("#isUnitPrice" + index + "ErrMsg").text("");
                    var itemIndex = inValidComponent.indexOf(`isUnitPrice${index}`);
                    if (itemIndex != -1) {
                        inValidComponent.splice(itemIndex, 1);
                    }
                }
            }
        });
        const validationResult = validateFields(validateField, true);
        validationResult.InValidFields.forEach((element, index) => {
            $("#" + element.Id + "ErrMsg").text(`${t("ErrorMessage.RequiredMsg")}`);
        });
        validationResult.ValidFields.forEach((element, index) => {
            $("#" + element.Id + "ErrMsg").text("");
        });
        if (validationResult.IsValid === true && inValidComponent.length === 0) {
            return true;
        } else {
            return false;
        }
    }
    AddNewServiceYear() {
        const { applicableServiceType } = this.props;
        let isValidMiscCharge = this.miscChargeValidation();
        if (!isValidMiscCharge) {
            return;
        }
        let result = [];
        let result1 = this.state.ServiceTypeList;
        let result2 = this.state.selectedServiceYears;
        console.log("selected", this.state.selectedServiceYears);
        result = result1.filter(function (obj) {
            return result2.indexOf(obj.item) === -1;
        });
        var arrayStroage = this.state.AddServiceYear;
        var arrayLength = 0;

        arrayLength = this.state.AddServiceYear.length;

        console.log("service years:", result);
        this.setState({
            AddServiceYear: [
                ...this.state.AddServiceYear,
                {
                    shipId: this.state.AddServiceYear[0].shipId,
                    equipmentId: this.state.AddServiceYear[0].equipmentId,
                    Id: arrayLength + 1,
                    serviceTypeId: 0,
                    servicetypelist: result,
                    isShore: false,
                    radioButton: "",
                    isDeleted: false,
                },
            ],
        });
    }
    handleSelectYear = (e, i) => {
        let value = parseInt(e.target.value);
        let ServiceTypeList = this.state.ServiceTypeList.filter(
            (i) => i.item === value
        );
        let x = this.state.selectedServiceYears;
        x.push(value);
        this.setState({ selectedServiceYears: x });
        console.log("selected", this.state.selectedServiceYears);
        let AddServiceYear = this.state.AddServiceYear;
        AddServiceYear[i][e.target.name] = parseInt(e.target.value);
        AddServiceYear[i]["serviceTypeName"] = ServiceTypeList[0].serviceTypes;
        this.setState({ AddServiceYear });
    };
    DeleteServiceYear(index) {
        const serviceCharges = [...this.state.AddServiceYear];
        serviceCharges.splice(index, 1);
        if (this.state.selectedServiceYears.length > 1) {
            const selectedServiceYear = [...this.state.selectedServiceYears];
            selectedServiceYear.splice(index, 1);
            this.state.selectedServiceYears = selectedServiceYear;
            this.setState({});
        }
        this.state.AddServiceYear = serviceCharges;
        this.setState({});
    }
    showModal = (ModelId, isModelNew) => {
        fileDatas = [];
        this.setState(
            {
                modalIsOpen: !this.state.modalIsOpen,
                openAlert: true,
            },
            () => {
                this.ClearServiceYear();
            }
        );
    };
    ClearServiceYear() {
        const { match } = this.props;
        const Id = parseInt(match.params.id);
        var arrayStroage = this.props?.applicableServiceType;
        var arrayLength = arrayStroage?.length;
        this.setState({
            AddServiceYear: [
                {
                    shipId: this.state.AddServiceYear[0].shipId
                        ? this.state.AddServiceYear[0].shipId
                        : Id,
                    equipmentId: this.state.AddServiceYear[0].equipmentId,
                    Id: arrayLength >= 0 ? arrayLength + 1 : 0,
                    serviceTypeId: 0,
                    serviceTypeName: "",
                    servicetypelist: this.state.ServiceTypeList,
                    isShore: false,
                    radioButton: "",
                    isDeleted: false,
                },
            ],
            selectedServiceYears: [],
        });
    }

    getEquipmentCategoryType = () => {
        let url = `${API.equipmentLookups}?lookupType=${"EquipmentCategoryType"}`;
        axios.get(url).then((response) => {
            this.setState({ equipemntCategoryTypeList: response.data });
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="pb-3">
                <Modal
                    size="md"
                    show={this.state.modalIsOpen}
                    onHide={() => {
                        this.showModal(0, true);
                    }}
                    aria-labelledby="example-modal-sizes-title-sm"
                    backdrop="static"
                    centered="true"
                    animation="true"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-sm">
                            {t("content.Servicetype")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.AddServiceYear.map((x, index) => {
                            return (
                                <>
                                    <div className="row pt-2">
                                        <div className="col-sm-5">
                                            <select
                                                className="form-control"
                                                name="serviceTypeId"
                                                id={`chargeDescription${index}`}
                                                value={x.serviceTypeId == 0 ? "" : x.serviceTypeId}
                                                onChange={(e) => this.handleSelectYear(e, index, false)}
                                            >
                                                <option value="">{t("ClassScreen.SelectServiceYear")}</option>
                                                {x &&
                                                    x?.servicetypelist?.map((name) => (
                                                        <option value={name.item}>
                                                            {name.serviceTypes}
                                                        </option>
                                                    ))}
                                            </select>
                                            <span
                                                id={`chargeDescription${index}ErrMsg`}
                                                className="spanErrMsg ml-2"
                                            ></span>
                                        </div>
                                        <div className="col-sm-5" style={{ lineHeight: "0px" }}>
                                            <RadioGroup
                                                className="radio-value"
                                                row
                                                name="radioButton"
                                                id={`isUnitPrice${index}`}
                                                value={x.radioButton}
                                                onChange={(e) =>
                                                    this.handleRadioButtonChanges(e, index)
                                                }
                                            >
                                                <FormControlLabel
                                                    className="mt-0"
                                                    style={{ marginBottom: "11px" }}
                                                    value="Ship"
                                                    control={<Radio color="default" size="small" />}
                                                    label={t("Generateservicerequestcontent.Ship")}
                                                />
                                                <FormControlLabel
                                                    className="mt-0"
                                                    style={{ marginBottom: "11px" }}
                                                    value="Shore"
                                                    control={<Radio color="default" size="small" />}
                                                    label={t("Generateservicerequestcontent.Shore")}
                                                />
                                            </RadioGroup>
                                            <span
                                                id={`isUnitPrice${index}ErrMsg`}
                                                className="spanErrMsg ml-2"
                                            ></span>
                                        </div>
                                        <div
                                            className={`col-sm-2 ${this.state.isOwner ? "" : "d-none"
                                                }`}
                                        >
                                            <div
                                                className={`mr-3 pl-1 ${index === 0 ? "d-none" : ""}`}
                                            >
                                                <div
                                                    className="flex"
                                                    onClick={() => this.DeleteServiceYear(index)}
                                                >
                                                    <MinusIcon />
                                                </div>
                                            </div>
                                            <div
                                                className={`mr-3 pl-1 ${index === 0 ? "" : "d-none"}`}
                                            >
                                                <div
                                                    className="flex"
                                                    onClick={() => this.AddNewServiceYear()}
                                                >
                                                    <AddIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                        <div
                            className="form-group search-btn-col mt-4"
                            style={{ textAlign: "end" }}
                        >
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.addApplicableType()}
                            >
                                {t("ComplianceandBudgetScreen.Submit")}
                            </button>
                            <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="button"
                                onClick={() => this.showModal(0, true)}
                            >
                                {" "}
                                {t("ComplianceandBudgetScreen.Cancel")}{" "}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                {this.renderCardData()}
            </div>
        );
    }
    renderCardData() {
        console.log("certificate", this.state.lastannualServiceCertificate);
        const {
            showSidePane,
            editEquipment,
            EquipmentNameList,
            EquipmentDropDownList,
            PortNameList,
            applicableServiceType,
            Loading,
            EquipmentNameListAndId,
            MakeList,
            ModelList,
            PortListAll,
            CountryListAll,
            ServiceProviderPortListAll,
            ModelOthersList,
            t
        } = this.props;
        const { openAlert, MakeModelList } = this.state;
        const isArabic = i18n.language === 'arab'
        let EquipmentTypeList =
            EquipmentDropDownList &&
            EquipmentDropDownList.map((r) => r.equipmentType);
        let CategoryList =
            EquipmentDropDownList && EquipmentDropDownList.map((r) => r.category);
        let CapacityList =
            EquipmentDropDownList && EquipmentDropDownList.map((r) => r.capacity);

        CategoryList = [...new Set(CategoryList)];
        EquipmentTypeList = [...new Set(EquipmentTypeList)];

        var result = EquipmentNameListAndId.reduce((unique, o) => {
            if (!unique.some((obj) => obj.equipmentName === o.equipmentName)) {
                unique.push(o);
            }
            return unique;
        }, []);

        return (
            <div className="row">
                <div className="full-height">
                    <div className="row pt-3">
                        <div className="col-lg-12">
                            <div className="panel-box search-filter-box">
                                <button
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    onClick={() => this.hideSidePanel()}
                                >
                                    &larr; {t("CommonText.Return")}
                                </button>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div
                                            className="card mt-2 MM-card-header"
                                            style={{ backgroundColor: "white" }}
                                        >
                                            <div
                                                className="card-body"
                                                style={{
                                                    padding: "0rem",
                                                    backgroundColor: "#1a3464",
                                                    color: "white",
                                                }}
                                            >
                                                <h5
                                                    className="card-title ml-2 mt-2"
                                                    style={{ color: "092a51" }}
                                                >
                                                    {t("ShipDetailsScreen.EquipmentDetails")}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="row pt-2 pb-4 search-filter-box">
                                            {/* <div className="col-lg-6">
                        <label className="form-label">Equipment Name</label>
                        <br></br>
                        <select
                          className="form-control"
                          name="equipment"
                          value={this.state.equipmentinfo.equipment}
                          onChange={(e) => this.handleInputChange(e)}
                          disabled={editEquipment ? true : false}
                        >
                          <option value="">Select Equipment Name </option>
                          {EquipmentNameList &&
                            EquipmentNameList.equipment.map((equipment) => (
                              <option value={equipment}>{equipment}</option>
                            ))}
                        </select>
                      </div> */}
                                            <div className="col-lg-6">
                                                <div
                                                    className="autocomplete-wrappers" style={{
                                                        zIndex: openAlert ? 99 : this.state.openEquipment && !Loading ? 99999 : null
                                                    }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("ShipEquipmentStatusScreen.EquipmentName")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={editEquipment ? true : false}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openEquipment = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openEquipment : false}
                                                        value={this.state.equipmentinfo.equipment}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control equipment"
                                                                    id="exampleFormControlInput1"
                                                                    disabled={editEquipment ? true : false}
                                                                    {...props}
                                                                />
                                                            );
                                                        }}
                                                        inputProps={{
                                                            placeholder: `${t("EditEquipmentScreenContent.SelectEquipmentName")}`,
                                                        }}
                                                        items={result ?? []}
                                                        getItemValue={(item) => item.equipmentName}
                                                        shouldItemRender={this.renderEquipmentTitle.bind(
                                                            this
                                                        )}
                                                        renderMenu={(item) => (
                                                            <div className="dropdown">{item}</div>
                                                        )}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.equipmentName}
                                                                {/* &nbsp; ({(item.category && (item.capacity || item.equipmentType)) ? item.category + "," : item.category ? item.category : ""}&nbsp; {(item.capacity && (item.category || item.equipmentType)) ? item.capacity + "," : item.capacity ? item.capacity : ""}&nbsp; {item.equipmentType ? item.equipmentType : ""}) */}
                                                            </div>
                                                        )}
                                                        onChange={(e) =>
                                                            this.handleInputChanges(e, "equipment")
                                                        }
                                                        onSelect={(value, item) =>
                                                            this.handleSelectChange(
                                                                value,
                                                                "equipment",
                                                                item.equipmentId,
                                                                item
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        id="EquipmentErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                </div>
                                            </div>
                                            {/* <div className="col-lg-6">
                                                <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                                                <br></br>
                                                <MaterialAutocomplete
                                                    value={this.state?.selectedEquipmentTypes}
                                                    options={this.state?.equipemntConfigTypeList ?? []}
                                                    getOptionLabel={(item) => item?.lookUpName || ""}
                                                    style={{ marginTop: "-17px" }}
                                                    noOptionsText={t("CommonText.NoOption")}
                                                    size={"small"}
                                                    onChange={(e, value) => this.onEquipmentTypeChange(e, value?.lookUpId, value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                                                            margin="normal"
                                                        />
                                                    )}
                                                    disabled={editEquipment ? true : false}
                                                />
                                            </div> */}
                                            <div className="col-lg-6">
                                                <label className="form-label fontstyle required">
                                                    {t("TopPaneContent.Category")}
                                                </label>
                                                <br></br>
                                                <select
                                                    className="form-control"
                                                    name="category"
                                                    value={this.state.equipmentinfo.category}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    disabled={editEquipment ? true : false}
                                                    onClick={() => $("#categoryErrMsg").text(!this.state.equipmentinfo?.equipment ? `${t("ErrorMessage.EquipmentRequired")}` : '')}
                                                >
                                                    <option value="">{t("EquipmentManagementScreenContent.SelectCategory")} </option>
                                                    {CategoryList &&
                                                        CategoryList.map((categoryname) => (
                                                            <option value={categoryname}>
                                                                {categoryname}
                                                            </option>
                                                        ))}
                                                </select>
                                                <span
                                                    id="categoryErrMsg"
                                                    className="spanErrMsg ml-2"
                                                ></span>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="autocomplete-wrappers"
                                                    style={{
                                                        zIndex: openAlert
                                                            ? 99 : this.state.openEquipmentType && !Loading ? 99999 : null,
                                                    }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("ShipEquipmentStatusScreen.Type")}
                                                    </label>
                                                    <br></br>
                                                    <div className="ac-wrapper" onClick={() => $("#equipmenttypeErrMsg").text(!this.state.equipmentinfo?.equipment ? `${t("ErrorMessage.EquipmentRequired")}` : '')}>
                                                        <Autocomplete
                                                            contentEditable={editEquipment ? true : false}
                                                            onMenuVisibilityChange={(isOpen) => {
                                                                this.state.openEquipmentType = isOpen;
                                                                this.setState({});
                                                            }}

                                                            open={!Loading ? this.state.openEquipmentType : false}
                                                            value={this.state.equipmentinfo.equipmentType}
                                                            renderInput={(props) => {
                                                                return (
                                                                    <input className="form-control equipment" id="exampleFormControlInput1" disabled={editEquipment ? true : false} {...props}
                                                                    />
                                                                );
                                                            }}
                                                            inputProps={{
                                                                placeholder: `${t("EditEquipmentScreenContent.SelectType")}`,
                                                            }}
                                                            items={EquipmentTypeList ?? []}
                                                            getItemValue={(item) => item}
                                                            shouldItemRender={this.renderEquipmentTypeTitle.bind(this)}
                                                            renderMenu={(item) => (
                                                                <div className="dropdown">{item}</div>
                                                            )}

                                                            renderItem={(item, isHighlighted) => (
                                                                <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                    {item}
                                                                </div>
                                                            )}
                                                            onChange={(e) => this.handleEquipmentTypeSearchChanges(e, "equipmentType")}
                                                            onSelect={(value, item) => this.handleEquipmentTypeSelectChange(value, "equipmentType")}
                                                        />
                                                    </div>
                                                    <span
                                                        id="equipmenttypeErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <label className="form-label fontstyle required">
                                                    {t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")}
                                                </label>
                                                <br></br>
                                                <select
                                                    className="form-control"
                                                    name="capacity"
                                                    value={this.state.equipmentinfo.capacity}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    disabled={editEquipment ? true : false}
                                                    onClick={() => $("#capacityErrMsg").text(!this.state.equipmentinfo?.equipment ? `${t("ErrorMessage.EquipmentRequired")}` : '')}
                                                >
                                                    <option value="">{t("EditEquipmentScreenContent.SelectCapacity")}</option>
                                                    {CapacityList &&
                                                        CapacityList.map((CapacityValue) => (
                                                            <option value={CapacityValue}>
                                                                {CapacityValue}
                                                            </option>
                                                        ))}
                                                </select>
                                                <span
                                                    id="capacityErrMsg"
                                                    className="spanErrMsg ml-2"
                                                ></span>
                                            </div>
                                            <div className="col-lg-6">
                                                <label className="form-label fontstyle required">
                                                    {t("ShipEquipmentStatusScreen.ManufacturingDate")}
                                                </label>
                                                <br></br>
                                                <div
                                                    className="input-group add-on date datepicker"
                                                    data-date-format="yyyy-mm-dd"
                                                    style={{
                                                        zIndex:
                                                            !Loading &&
                                                                this.state.equipmentinfo.manufracturingDate
                                                                ? 99
                                                                : this.state.DatePickerIsOpen
                                                                    ? 99999
                                                                    : 99,
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control date-picker"
                                                        placeholder={t("ShipEquipmentStatusScreen.ManufacturingDate")}
                                                        value={
                                                            this.state.equipmentinfo.manufracturingDate
                                                                ? moment(
                                                                    this.state.equipmentinfo.manufracturingDate
                                                                ).format("YYYY-MM-DD")
                                                                : ""
                                                        }
                                                    // disabled={editEquipment ? true : false}
                                                    ></input>
                                                    <DatePicker
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={this.handleManufacturingDate}
                                                        open={this.state.DatePickerIsOpen}
                                                        onClickOutside={this.handleBlur}
                                                        // disabled={editEquipment ? true : false}
                                                        dropdownMode="select"
                                                        popperPlacement="top-end"
                                                        className="form-control date-picker w-5 hide-date"
                                                    />
                                                    <div
                                                        className="input-group-btn calendar-icon"
                                                        onClick={this.openDatePicker}
                                                    >
                                                        <button
                                                            className="btn btn-default"
                                                            style={{ height: "100%" }}
                                                        // disabled={editEquipment ? true : false}
                                                        >
                                                            <i className="fa fa-calendar mt-1"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <span
                                                    id="ManufactureDateErrMsg"
                                                    className="spanErrMsg ml-2"
                                                ></span>
                                            </div>
                                            <div
                                                id="LifeBoatEquipment" className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.openLifeMake && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.LifeboatMake")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.equipmentinfo.lifeboatMake}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openLifeMake = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openLifeMake : false}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                                                            );
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.LifeboatMake")}` }}
                                                        items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderMakeTitle.bind(this)}
                                                        renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleLifeBoatMakeSearchChanges(e, "lifeboatMakeId")}
                                                        onSelect={(value, item) => this.handleLifeBoatMakeSelectChange(value, "lifeboatMakeId", item.id)} />
                                                    <span
                                                        id="lifeboatmakeErrMsg"
                                                        className="spanErrMsg ml-2"></span>
                                                    <span
                                                        id="LifeMakeValidationErrMsg"
                                                        className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div
                                                id="LifeBoatEquipment1"
                                                className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.openDavitMake && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.Davit/winchMake")}</label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.equipmentinfo.davitwinchMake}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openDavitMake = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openDavitMake : false}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                                                            );
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.Davit/winchMake")}` }}
                                                        items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderMakeTitle.bind(this)}
                                                        renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleLifeBoatMakeSearchChanges(e, "davitwinchMakeId")}
                                                        onSelect={(value, item) => this.handleLifeBoatMakeSelectChange(value, "davitwinchMakeId", item.id)} />
                                                    <span
                                                        id="davitwinchmakeErrMsg"
                                                        className="spanErrMsg ml-2"></span>
                                                    <span
                                                        id="LifeDavitValidationErrMsg"
                                                        className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div
                                                id="LifeBoatEquipment3"
                                                className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.openLifeBoatModel && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.LifeboatModel")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openLifeBoatModel = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openLifeBoatModel : false}
                                                        value={this.state.equipmentinfo?.lifeboatModel}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control equipment" id="exampleFormControlInput1" {...props}
                                                                />);
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.LifeboatModel")}` }}
                                                        items={ModelList?.length === 0 ? MakeModelList ?? [] : ModelList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderModelTitle.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleLifeBoatModelSearchChanges(e, "lifeboattModelId")}
                                                        onSelect={(value, item) => this.handleLifeBoatModelSelectChange(value, "lifeboatModelId", item.id
                                                        )} />
                                                    <span
                                                        id="lifeboatmodelErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span id="LifeModelValidationErrMsg" className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div
                                                id="LifeBoatEquipment2"
                                                className="col-lg-6 lifeBoat-hide mt-3">
                                                <label className="form-label fontstyle required">
                                                    {t("EditEquipmentScreenContent.LifeboatRelease")}
                                                </label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="lifeboatRelease"
                                                    id="lifeboatrelease"
                                                    placeholder={t("EditEquipmentScreenContent.LifeboatRelease")}
                                                    value={this.state.equipmentinfo.lifeboatRelease}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                ></input>
                                                <span
                                                    id="lifeboatreleaseErrMsg"
                                                    className="spanErrMsg ml-2"
                                                ></span>
                                            </div>
                                            <div
                                                id="rescueboatEquipment"
                                                className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.openRescueMake && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.rescueboatMake")}</label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.equipmentinfo.rescueboatMake}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openRescueMake = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openRescueMake : false}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                                                            );
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatMake")}` }}
                                                        items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderMakeTitle.bind(this)}
                                                        renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleRescueBoatMakeSearchChanges(e, "rescueboatMakeId")}
                                                        onSelect={(value, item) => this.handleRescueBoatMakeSelectChange(value, "rescueboatMakeId", item.id)} />
                                                    <span
                                                        id="rescueboatmakeErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span id="rescueMakeValidationErrMsg" className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div id="rescueboatEquipment1" className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.rescueWinchMake && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}</label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.rescueWinchMake = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.rescueWinchMake : false}
                                                        value={this.state.equipmentinfo.rescueboatdavitwinchMake}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input className="form-control equipment" id="exampleFormControlInput1" {...props} />
                                                            );
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}`, }}
                                                        items={MakeList?.length === 0 ? MakeModelList : MakeList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderMakeTitle.bind(this)}
                                                        renderMenu={(item) => (<div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleRescueBoatMakeSearchChanges(e, "rescueboatdavitwinchMakeId")}
                                                        onSelect={(value, item) => this.handleRescueBoatMakeSelectChange(value, "rescueboatdavitwinchMakeId", item.id)} />
                                                    <span
                                                        id="rescueboatdavitwinchmakeErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span id="rescueDavitValidationErrMsg" className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div id="rescueboatEquipment3" className="col-lg-6 lifeBoat-hide">
                                                <div className="autocomplete-wrappers" style={{
                                                    zIndex: openAlert ? 99 : this.state.openModel && !Loading ? 99999 : null
                                                }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("EditEquipmentScreenContent.rescueboatModel")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openModel = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openModel : false}
                                                        value={this.state.equipmentinfo.rescueboatModel}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control equipment" id="exampleFormControlInput1" {...props}
                                                                />);
                                                        }}
                                                        inputProps={{ placeholder: `${t("EditEquipmentScreenContent.rescueboatModel")}` }}
                                                        items={ModelList?.length === 0 ? MakeModelList ?? [] : ModelList ?? []}
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderModelTitle.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdown">{item}</div>)}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                                                {item.name}</div>)}
                                                        onChange={(e) => this.handleRescueBoatModelSearchChanges(e, "rescueboatModelId")}
                                                        onSelect={(value, item) => this.handleRescueBoatModelSelectChange(value, "rescueboatModelId", item.id
                                                        )} />
                                                    <span
                                                        id="rescueboatmodelErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span id="rescueModelValidationErrMsg" className="spanErrMsg ml-2"></span>
                                                </div>
                                            </div>
                                            <div
                                                id="rescueboatEquipment2"
                                                className="col-lg-6 lifeBoat-hide">
                                                <label className="form-label fontstyle required">
                                                    {t("EditEquipmentScreenContent.rescueboatRelease")}
                                                </label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="rescueboatRelease"
                                                    id="rescueboatrelease"
                                                    placeholder={t("EditEquipmentScreenContent.rescueboatRelease")}
                                                    value={this.state.equipmentinfo.rescueboatRelease}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                ></input>
                                                <span
                                                    id="rescueboatreleaseErrMsg"
                                                    className="spanErrMsg ml-2"
                                                ></span>
                                            </div>
                                            <div className="col-lg-6" id="MakeHide">
                                                <div
                                                    className="autocomplete-wrappers"
                                                    style={{ zIndex: openAlert ? 99 : 999 }}
                                                >
                                                    <label className="form-label fontstyle required">
                                                        {t("ShipEquipmentStatusScreen.Make")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.equipmentinfo.make}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control equipment"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                />
                                                            );
                                                        }}
                                                        inputProps={{
                                                            placeholder: `${t("MakeAndModelScreen.SelectMake")}`,
                                                        }}
                                                        items={
                                                            MakeList?.length === 0
                                                                ? MakeModelList
                                                                : MakeList ?? []
                                                        }
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderMakeTitle.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdown">{item}</div>
                                                        )}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.name}
                                                            </div>
                                                        )}
                                                        onChange={(e) =>
                                                            this.handleMakeSearchChanges(e, "makeId")
                                                        }
                                                        onSelect={(value, item) =>
                                                            this.handleMakeSelectChange(
                                                                value,
                                                                "makeId",
                                                                item.id
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        id="MakeErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span
                                                        id="MakeValidationErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                </div>
                                            </div>

                                            <div className="col-lg-6" id="ModelHide">
                                                <div className="autocomplete-wrappers"
                                                    style={{
                                                        zIndex: openAlert
                                                            ? 99 : this.state.openModel && !Loading ? 99999 : null,
                                                    }}>
                                                    <label className="form-label fontstyle required">
                                                        {t("ShipEquipmentStatusScreen.Model")}
                                                    </label>
                                                    <br></br>
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        onMenuVisibilityChange={(isOpen) => {
                                                            this.state.openModel = isOpen;
                                                            this.setState({});
                                                        }}
                                                        open={!Loading ? this.state.openModel : false}
                                                        value={this.state.equipmentinfo.model}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control equipment"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                />
                                                            );
                                                        }}
                                                        inputProps={{
                                                            placeholder: `${t("MakeAndModelScreen.SelectModel")}`,
                                                        }}
                                                        items={
                                                            ModelList?.length === 0
                                                                ? MakeModelList ?? []
                                                                : ModelList ?? []
                                                        }
                                                        getItemValue={(item) => item.name}
                                                        shouldItemRender={this.renderModelTitle.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdown">{item}</div>
                                                        )}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.name}
                                                            </div>
                                                        )}
                                                        onChange={(e) =>
                                                            this.handleModelSearchChanges(e, "modelId")
                                                        }
                                                        onSelect={(value, item) =>
                                                            this.handleModelSelectChange(
                                                                value,
                                                                "modelId",
                                                                item.id
                                                            )
                                                        }
                                                    />
                                                    <span
                                                        id="ModelErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                    <span
                                                        id="ModelValidationErrMsg"
                                                        className="spanErrMsg ml-2"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 ">
                                                <label className="form-label fontstyle required" id="categoryequiptype">
                                                    {t("ShipEquipmentStatusScreen.Quantity")}
                                                </label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    name="quantity"
                                                    id="quantity"
                                                    placeholder={t("ShipEquipmentStatusScreen.Quantity")}
                                                    value={this.state.equipmentinfo.quantity}
                                                    onChange={(e) => this.handleInputChange(e)}></input>
                                                <span
                                                    id="EquipquantityErrMsg"
                                                    className="spanErrMsg"
                                                ></span>
                                                {/* <span id="quantityErrMsg" className="spanErrMsg"></span> */}
                                            </div>
                                            <div className="col-lg-6">
                                                <label className="form-label fontstyle required">
                                                    {t("ShipEquipmentStatusScreen.Unit-Quantity")}
                                                </label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="unit"
                                                    placeholder={t("ShipEquipmentStatusScreen.Unit-Quantity")}
                                                    value={this.state.equipmentinfo.unit}
                                                    onChange={(e) => this.handleInputChange(e)}
                                                ></input>
                                                <span
                                                    id="EquipunitErrMsg"
                                                    className="spanErrMsg"
                                                ></span>
                                            </div>
                                            {/* <div className="col-lg-6 ">
                                                <label className="form-label fontstyle required">{t("EquipmentManagementScreenContent.isContract")} </label>
                                                <br></br>
                                                <div className="row">
                                                    <div className={"col-sm-3 mt-2 clsm-3"}>
                                                        <input
                                                            type="radio"
                                                            checked={this.state.isContractApplicableYes}
                                                            onChange={(e) => this.handleInputChanges(e, "isContractApplicableYes")}></input>
                                                        <span className="ml-1">{t("confirmAlertMessage.Yes")}</span>
                                                    </div>
                                                    <div className={"col-sm-9 mt-2 clsm-9"}>
                                                        <input
                                                            type="radio"
                                                            checked={this.state.isContractApplicableNo}
                                                            onChange={(e) => this.handleInputChanges(e, "isContractApplicableNo")}></input>
                                                        <span className="ml-1">{t("confirmAlertMessage.No")}</span>
                                                    </div>
                                                </div>
                                                <span id="contractErrMsg" className="spanErrMsg"></span>
                                            </div> */}
                                            {/* <div className="col-lg-6">
                        <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                        <br></br>
                        <select
                          className="form-control"
                          id="equipmentType"
                          name="equipmentTypeid"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.equipmentinfo?.equipmentTypeid}
                        >
                          <option value="">{t("EquipmentManagementScreenContent.SelectEquipmentType")}</option>
                          <option value="1">Contract</option>
                          <option value="2">Add On</option>
                          <option value="3">Adhoc</option>
                          {
                            this.state.equipemntConfigTypeList?.length > 0 && this.state.equipemntConfigTypeList.map(x => {
                              return <option value={x.id}>{x.value}</option>
                            })
                          }

                        </select>
                      </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row pb-4">
                                    <div className="col-lg-12">
                                        <div
                                            className="card mt-2 MM-card-header"
                                            style={{ backgroundColor: "white" }}
                                        >
                                            <div
                                                className="card-body flex"
                                                style={{
                                                    padding: "0rem",
                                                    backgroundColor: "#1a3464",
                                                    color: "white",
                                                }}
                                            >
                                                <h5
                                                    className="card-title ml-2 mt-2 f2"
                                                    style={{ color: "092a51" }}
                                                >
                                                    {t("ApplicableServiceType.Title")}
                                                </h5>
                                                {/* {this.state.openOwnerRequirement ? (
                          <div
                            className="m-1 flex"
                            onClick={() => this.showModal(0, true)}
                          >
                            <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                            <AddIcon />
                          </div>
                        ) : null} */}
                                            </div>
                                        </div>
                                        {applicableServiceType && applicableServiceType.length
                                            ? applicableServiceType.map((servicename, index) => (
                                                <div className="row justify-content-end search-filter-box pb-0">
                                                    <div className="col-lg-6">
                                                        <label className="form-label">
                                                            {t('ApplicableServiceType.ServiceType')}
                                                        </label>
                                                        <br></br>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={`${servicename.serviceType} Service `}
                                                                disabled
                                                            ></input>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label className="form-label">{t("EquipmentTypeScreen.Title")}</label>
                                                        <br></br>
                                                        <MaterialAutocomplete
                                                            // value={this.state?.selectedEquipmentTypes}
                                                            value={this.state.applicableServiceEquipType[index]?.applicableEquipType || null}
                                                            options={this.state?.equipemntConfigTypeList ?? []}
                                                            getOptionLabel={(item) => item?.lookUpName || ""}
                                                            style={{ marginTop: "-17px" }}
                                                            noOptionsText={t("CommonText.NoOption")}
                                                            size={"small"}
                                                            onChange={(e, value) => this.onEquipTypeChange(e, value, index, servicename)}
                                                            // onChange={(e, value) => this.onEquipmentTypeChange(e, value?.lookUpId, value)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={t("EquipmentManagementScreenContent.SelectEquipmentType")}
                                                                    margin="normal"
                                                                />
                                                            )}
                                                        // disabled={editEquipment ? true : false}
                                                        />
                                                        <span id={`equipmentContractTypeError${index}`} className="spanErrMsg ml-2"></span>
                                                    </div>
                                                </div>
                                            )) : ''}
                                        <span
                                            id="EquipmentTypeErrMsg"
                                            className="spanErrMsg ml-2"
                                        ></span>

                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div
                                            className="card mt-2 MM-card-header"
                                            style={{ backgroundColor: "white" }}
                                        >
                                            <div
                                                className="card-body flex"
                                                style={{
                                                    padding: "0rem",
                                                    backgroundColor: "#1a3464",
                                                    color: "white",
                                                }}
                                            >
                                                <h5
                                                    className="card-title ml-2 mt-2 f2"
                                                    style={{ color: "092a51" }}
                                                >
                                                    {t("EditEquipmentScreenContent.ServiceDetails")}
                                                </h5>
                                                {this.state.openOwnerRequirement ? (
                                                    <div
                                                        className="m-1 flex"
                                                        onClick={() => this.showModal(0, true)}
                                                    >
                                                        <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                                                        <AddIcon />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {applicableServiceType && applicableServiceType.length
                                            ? applicableServiceType.map((servicename, index) => (
                                                <div key={index}>
                                                    <div className="row justify-content-end search-filter-box pb-0">
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn text-right txtht-btn blue"
                                                            type="submit"
                                                            onClick={() =>
                                                                this.resetServiceDetails(
                                                                    servicename.serviceType
                                                                )
                                                            }
                                                        >
                                                            {" "}
                                                            <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                                                <span>
                                                                    {t("EditEquipmentScreenContent.Reset")}
                                                                </span>
                                                            </span>{" "}
                                                            <span> {servicename.serviceType}</span>
                                                        </button>
                                                    </div>
                                                    <div className="row  pt-2 pb-4 search-filter-box">
                                                        <div className="col-lg-6">
                                                            <label className="form-label">
                                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceDone")}
                                                            </label>
                                                            <br></br>
                                                            <div
                                                                className="input-group add-on date datepicker"
                                                                data-date-format="yyyy-mm-dd"
                                                                style={{
                                                                    zIndex:
                                                                        !Loading && this.state[
                                                                            "lastannualDatePickerIsOpen" +
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                "")
                                                                        ]
                                                                            ? 99999
                                                                            : 99,
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    className="form-control date-picker"
                                                                    placeholder={`${t("ServiceDetails.Last")} ${servicename.serviceType} ${t("ServiceDetails.ServiceDone")}`}
                                                                    value={
                                                                        this.state["lastDoneDate" + servicename?.serviceType?.replace(/ +/g, "")]
                                                                    }
                                                                ></input>
                                                                <DatePicker
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    popperPlacement="top-end"
                                                                    /*    onClickOutside={this.DatePickerOnBlur(servicename?.serviceType?.replace(
                                                                    / +/g,
                                                                    ""
                                                                  ))} */
                                                                    onChange={(e) =>
                                                                        this.handleServiceDateChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""),
                                                                            servicename.interval, servicename.serviceTypeId
                                                                        )
                                                                    }
                                                                    open={
                                                                        this.state[
                                                                        "lastannualDatePickerIsOpen" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ]
                                                                    }
                                                                    className="form-control date-picker w-5 hide-date"
                                                                />
                                                                <div
                                                                    className="input-group-btn calendar-icon"
                                                                    onClick={() =>
                                                                        this.openannualDatePicker(
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                        )
                                                                    }
                                                                >
                                                                    <button
                                                                        className="btn btn-default"
                                                                        style={{ height: "100%" }}
                                                                    >
                                                                        <i className="fa fa-calendar mt-1"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <span id={`lastDoneDateError${index}`} className="spanErrMsg ml-2"></span>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">
                                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Next")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceDue")}
                                                            </label>
                                                            <br></br>
                                                            <div
                                                                className="input-group add-on date datepicker"
                                                                data-date-format="yyyy-mm-dd"
                                                                style={{
                                                                    zIndex:
                                                                        !Loading &&
                                                                            this.state[
                                                                            "nextannualDatePickerIsOpen" +
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                            ]
                                                                            ? 99999
                                                                            : 99,
                                                                }}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    className="form-control date-picker"
                                                                    placeholder={`${t("ServiceDetails.Next")} ${servicename.serviceType} ${t("ServiceDetails.ServiceDue")}`}
                                                                    value={
                                                                        this.state[
                                                                        "nextDueDate" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ]
                                                                    }
                                                                ></input>
                                                                <DatePicker
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    popperPlacement="top-end"
                                                                    onClickOutside={this.handleBlur}
                                                                    onChange={(e) =>
                                                                        this.handlenextServiceDateChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                        )
                                                                    }
                                                                    open={
                                                                        this.state[
                                                                        "nextannualDatePickerIsOpen" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ]
                                                                    }
                                                                    dropdownMode="select"
                                                                    className="form-control date-picker w-5 hide-date"
                                                                />
                                                                <div
                                                                    className="input-group-btn calendar-icon"
                                                                    onClick={() =>
                                                                        this.nextannualDatePicker(
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                        )
                                                                    }
                                                                >
                                                                    <button
                                                                        className="btn btn-default"
                                                                        style={{ height: "100%" }}
                                                                    >
                                                                        <i className="fa fa-calendar mt-1"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <span id={`nextDueDateError${index}`} className="spanErrMsg ml-2"></span>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div
                                                                className="autocomplete-wrappers"
                                                                style={{
                                                                    zIndex: !Loading && openAlert ? 99 :
                                                                        Loading && openAlert ? 99 :
                                                                            9999,
                                                                }}
                                                            >
                                                                <label className="form-label">
                                                                    <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServicePort")}
                                                                </label>
                                                                <br></br>
                                                                <Autocomplete
                                                                    contentEditable={true}
                                                                    value={
                                                                        this.state[
                                                                        "lastDonePort" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ] ?? ""
                                                                    }
                                                                    inputProps={{
                                                                        placeholder: t('VendorManagementScreenContent.SelectPort'),
                                                                    }}
                                                                    items={
                                                                        this.state[
                                                                            "PortList" +
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                        ]
                                                                            ? this.state[
                                                                            "PortList" +
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                            ] ?? []
                                                                            : PortListAll ?? []
                                                                    }
                                                                    getItemValue={(item) => item.port}
                                                                    shouldItemRender={this.renderPortTitle.bind(
                                                                        this
                                                                    )}
                                                                    renderMenu={(item) => (
                                                                        <div className="dropdown">{item}</div>
                                                                    )}
                                                                    renderItem={(item, isHighlighted) => (
                                                                        <div
                                                                            className={`items ${isHighlighted ? "selected-items" : ""
                                                                                }`}
                                                                            key={item.portId}
                                                                        >
                                                                            {item.port}
                                                                        </div>
                                                                    )}
                                                                    onChange={(e) =>
                                                                        this.handleAnnualSearchChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDonePort"
                                                                        )
                                                                    }
                                                                    onSelect={(e, item) =>
                                                                        this.handleAnnualSelectChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDonePort",
                                                                            item.portId
                                                                        )
                                                                    }
                                                                />
                                                                <span id={`lastDonePortError${index}`} className="spanErrMsg ml-2"></span>
                                                            </div>
                                                            {/* <label className="form-label">
                                Last {servicename.serviceType} Service Port
                              </label>
                              <br></br>
                               <select
                                className="form-control"
                                name="lastDonePort"
                                value={
                                  this.state[
                                    "lastDonePort" +
                                      servicename.serviceType.replace(/ +/g, "")
                                  ]
                                }
                                onChange={(e) =>
                                  this.handleAnnualInputChange(
                                    e,
                                    servicename.serviceType.replace(/ +/g, "")
                                  )
                                }
                              >
                                <option value="">Select Port </option>
                                {PortNameList &&
                                  PortNameList.ports.map((portname) => (
                                    <option value={portname}>{portname}</option>
                                  ))}
                              </select> */}
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div
                                                                className="autocomplete-wrappers"
                                                                style={{ zIndex: openAlert ? 99 : 9999 }}
                                                            >
                                                                <label className="form-label">
                                                                    <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceCountry")}
                                                                </label>
                                                                <br></br>
                                                                <Autocomplete
                                                                    contentEditable={true}
                                                                    value={
                                                                        this.state[
                                                                        "lastDoneCountry" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ] ?? ""
                                                                    }
                                                                    inputProps={{
                                                                        placeholder: t('VendorManagementScreenContent.SelectCountry'),
                                                                    }}
                                                                    items={
                                                                        this.state[
                                                                        "CountryList" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ] ?? []
                                                                    }
                                                                    getItemValue={(item) => item.country}
                                                                    shouldItemRender={this.renderCountryTitle.bind(
                                                                        this
                                                                    )}
                                                                    renderMenu={(item) => (
                                                                        <div className="dropdown">{item}</div>
                                                                    )}
                                                                    renderItem={(item, isHighlighted) => (
                                                                        <div
                                                                            className={`items ${isHighlighted ? "selected-items" : ""
                                                                                }`}
                                                                        >
                                                                            {item.country}
                                                                        </div>
                                                                    )}
                                                                    onChange={(e) =>
                                                                        this.handleAnnualSearchChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDoneCountry"
                                                                        )
                                                                    }
                                                                    onSelect={(e) =>
                                                                        this.handleAnnualSelectChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDoneCountry"
                                                                        )
                                                                    }
                                                                />
                                                                <span id={`lastDoneCountryError${index}`} className="spanErrMsg ml-2"></span>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div
                                                                className="autocomplete-wrappers"
                                                                style={{
                                                                    zIndex: openAlert
                                                                        ? 99
                                                                        : this.state.openServiceProvider &&
                                                                            !Loading
                                                                            ? 99999
                                                                            : null,
                                                                }}
                                                            >
                                                                <label className="form-label">
                                                                    <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceProvider")}
                                                                </label>
                                                                <br></br>
                                                                <Autocomplete
                                                                    contentEditable={true}
                                                                    value={
                                                                        this.state[
                                                                        "lastDoneServiceProvider" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ] ?? ""
                                                                    }
                                                                    onMenuVisibilityChange={(isOpen) => {
                                                                        this.state.openServiceProvider = isOpen;
                                                                        this.setState({});
                                                                    }}
                                                                    inputProps={{
                                                                        placeholder: `${t('content.Select')} ${t('ShipDetailsScreen.ServiceProvider')}`,
                                                                    }}
                                                                    items={
                                                                        this.state[
                                                                        "ServiceProviderList" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ] ?? []
                                                                    }
                                                                    getItemValue={(item) =>
                                                                        item.serviceProvider
                                                                    }
                                                                    shouldItemRender={this.renderServiceProviderTitle.bind(
                                                                        this
                                                                    )}
                                                                    renderMenu={(item) => (
                                                                        <div className="dropdown">{item}</div>
                                                                    )}
                                                                    renderItem={(item, isHighlighted) => (
                                                                        <div
                                                                            className={`items ${isHighlighted ? "selected-items" : ""
                                                                                }`}
                                                                        >
                                                                            {item.serviceProvider}
                                                                        </div>
                                                                    )}
                                                                    onChange={(e) =>
                                                                        this.handleAnnualSearchChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDoneServiceProvider"
                                                                        )
                                                                    }
                                                                    onSelect={(e) =>
                                                                        this.handleAnnualSelectChange(
                                                                            e,
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            ),
                                                                            "lastDoneServiceProvider"
                                                                        )
                                                                    }
                                                                />
                                                                <span id={`lastDoneServiceProviderError${index}`} className="spanErrMsg ml-2"></span>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <label className="form-label">
                                                                {servicename.serviceType} {t("ServiceDetails.ServiceType")}
                                                            </label>
                                                            <br></br>
                                                            <span>
                                                                {servicename?.isShip ? "Ship" : ""} {" "}{" "}
                                                                {servicename?.isShore ? "Shore" : ""}
                                                            </span>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <label className="form-label">
                                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServiceCertificate")}{" "}
                                                            </label>
                                                            <br></br>
                                                            <div class="input-group ">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">
                                                                        {t("ServiceDetails.BrowseFile")}
                                                                        <input
                                                                            type="file"
                                                                            id="files"
                                                                            style={{ marginRight: 40 }}
                                                                            name="lastannualServiceCertificate"
                                                                            onChange={(e) =>
                                                                                this.handleAnnualInputChange(
                                                                                    e,
                                                                                    servicename?.serviceType?.replace(
                                                                                        / +/g,
                                                                                        ""
                                                                                    )
                                                                                )
                                                                            }
                                                                            onClick={(event) => {
                                                                                event.currentTarget.value = null;
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder=""
                                                                    value={
                                                                        this.state[
                                                                        "lastannualServiceCertificate" +
                                                                        servicename?.serviceType?.replace(
                                                                            / +/g,
                                                                            ""
                                                                        )
                                                                        ]
                                                                    }
                                                                />
                                                                {this.state[
                                                                    "lastannualServiceCertificate" +
                                                                    servicename?.serviceType?.replace(
                                                                        / +/g,
                                                                        ""
                                                                    )
                                                                ] &&
                                                                    this.state[
                                                                    "attachmentName" +
                                                                    servicename?.serviceType?.replace(
                                                                        / +/g,
                                                                        ""
                                                                    )
                                                                    ] &&
                                                                    this.state[
                                                                    "attachmentGuid" +
                                                                    servicename?.serviceType?.replace(
                                                                        / +/g,
                                                                        ""
                                                                    )
                                                                    ] ? (
                                                                    <div
                                                                        class="input-group-append"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <i
                                                                            class="fa fa-times input-group-text"
                                                                            aria-hidden="true"
                                                                            onClick={() =>
                                                                                this.ClearInput(
                                                                                    servicename?.serviceType?.replace(
                                                                                        / +/g,
                                                                                        ""
                                                                                    )
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 hide-pic-option">
                                                            <label className="form-label">
                                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>{t("ServiceDetails.Last")}</span> {servicename.serviceType} {t("ServiceDetails.ServicePhotos")}{" "}
                                                            </label>
                                                            <br></br>
                                                            <div class="input-group">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">
                                                                        {t("ServiceDetails.BrowseFile")}
                                                                        <input
                                                                            type="file"
                                                                            id="files"
                                                                            style={{ marginRight: 40 }}
                                                                            multiple
                                                                            accept="image/*"
                                                                            name="lastannualServicePhoto"
                                                                            onChange={(e) =>
                                                                                this.handleAnnualInputChangeMultiple(
                                                                                    e,
                                                                                    servicename?.serviceType?.replace(
                                                                                        / +/g,
                                                                                        ""
                                                                                    )
                                                                                )
                                                                            }
                                                                            onClick={(event) => {
                                                                                event.currentTarget.value = null;
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                {/* <input
                                  type="text"
                                  class="form-control"
                                  placeholder=""
                                  value={
                                    this.state[
                                      "lastannualServiceCertificate" +
                                        servicename.serviceType.replace(
                                          / +/g,
                                          ""
                                        )
                                    ]
                                  }
                                /> */}
                                                                {/* {this.state[
                                  "lastannualServiceCertificate" +
                                    servicename.serviceType.replace(/ +/g, "")
                                ] &&
                                this.state[
                                  "attachmentName" +
                                    servicename.serviceType.replace(/ +/g, "")
                                ] &&
                                this.state[
                                  "attachmentGuid" +
                                    servicename.serviceType.replace(/ +/g, "")
                                ] ? (
                                  <div class="input-group-append">
                                    <i
                                      class="fa fa-times input-group-text"
                                      aria-hidden="true"
                                      onClick={() =>
                                        this.ClearInput(
                                          servicename.serviceType.replace(
                                            / +/g,
                                            ""
                                          )
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : (
                                  ""
                                )} */}
                                                                <div className="mui-select image-hide">
                                                                    <Multiselect
                                                                        //className="mui-select"
                                                                        isObject={true}
                                                                        showArrow={true}
                                                                        displayValue="name"
                                                                        emptyRecordMsg=""
                                                                        style={{
                                                                            // multiselectContainer: {
                                                                            //   width: "80%",
                                                                            //   marginRight: "-8px",
                                                                            // },
                                                                            searchBox: {
                                                                                borderTopLeftRadius: "0px",
                                                                                borderBottomLeftRadius: "0px",
                                                                                minHeight: "38px",
                                                                            },
                                                                            option: {
                                                                                "margin-right": 0,
                                                                                display: "block",
                                                                                "font-weight": "normal",
                                                                            },
                                                                            chips: {
                                                                                "background-color": "#1a3464",
                                                                            },
                                                                        }}
                                                                        // onSelect={(item) => this.onSelectChange(item)}
                                                                        onRemove={(item) =>
                                                                            this.onRemoveChange(
                                                                                item,
                                                                                "lastannualServicePhoto" +
                                                                                servicename?.serviceType?.replace(
                                                                                    / +/g,
                                                                                    ""
                                                                                )
                                                                            )
                                                                        }
                                                                        selectedValues={
                                                                            this.state[
                                                                            "lastannualServicePhoto" +
                                                                            servicename?.serviceType?.replace(
                                                                                / +/g,
                                                                                ""
                                                                            )
                                                                            ]
                                                                        }
                                                                        placeholder={""}
                                                                        closeIcon="cancel"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            : null}
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-lg-12 pl-3 pr-3 pb-3">
                                        <div
                                            className=" search-btn-col"
                                            style={{ textAlign: "end" }}
                                        >
                                            {editEquipment ? (
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.UpdateEquipment()}
                                                >
                                                    {" "}
                                                    {t("EquipmentServiceTypes.Update")}{" "}
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit"
                                                    onClick={() => this.AddEquipment()}
                                                >
                                                    {" "}
                                                    {t("ShipManagementContent.Add")}{" "}
                                                </button>
                                            )}
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button"
                                                onClick={() => this.hideSidePanel()}
                                            >
                                                {" "}
                                                {t("ComplianceandBudgetScreen.Cancel")}{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    hideSidePanel() {
        fileDatas = [];
        valueCheck = false;
        const { EquipmentArray } = this.props;
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.dispatch({ type: "getEquipmentDetails", data: EquipmentArray });
        this.props.history.goBack();
        /* this.props.history.push("/Home/GrandAdmin/ShipEditItem/:id"); */
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.showSidePane,
        editEquipment: state.MasterScreenReducer.editEquipment,
        EquipmentNameList: state.MasterScreenReducer.EquipmentNameList,
        CategoryList: state.MasterScreenReducer.CategoryList,
        EquipmentTypeList: state.MasterScreenReducer.EquipmentTypeList,
        annualAttachment: state.MasterScreenReducer.annualAttachment,
        biannualAttachment: state.MasterScreenReducer.biannualAttachment,
        fiveyearlyAttachment: state.MasterScreenReducer.fiveyearlyAttachment,
        tenyearlyAttachment: state.MasterScreenReducer.tenyearlyAttachment,
        EquipmentArray: state.MasterScreenReducer.ShipEquipmentDetails,
        PortNameList: state.MasterScreenReducer.PortNameList,
        applicableServiceType: state.MasterScreenReducer.applicableServiceTypeInterval,
        ServiceDate: state.MasterScreenReducer.ServiceDate,
        EquipmentObject: state.MasterScreenReducer.EquipmentObject,
        EquipmentDropDownList: state.MasterScreenReducer.EquipmentDropDownList,
        EquipmentArray: state.MasterScreenReducer.ShipEquipmentDetails,
        PortList: state.MasterScreenReducer.ShipPortList || [],
        CountryList: state.MasterScreenReducer.ShipCountryList || [],
        ServiceProviderPortList:
            state.MasterScreenReducer.ShipServiceProviderPortList || [],
        ServiceProviderId: state.MasterScreenReducer.ShipServiceProviderID || [],
        Loading: state.PageLoaderReducer.loading,
        EquipmentNameListAndId:
            state.MasterScreenReducer.EquipmentNameListAndId || [],
        serviceAttachment: state.MasterScreenReducer.serviceAttachment,
        PortListAll: state.MasterScreenReducer.ShipPortListAll || [],
        CountryListAll: state.MasterScreenReducer.ShipCountryListAll || [],
        ServiceProviderPortListAll:
            state.MasterScreenReducer.ShipServiceProviderPortListAll || [],
        MakeList: state.MasterScreenReducer.MakeEquipmentList,
        ModelList: state.MasterScreenReducer.ModelEquipmentList,
        ModelOthersList: state.MasterScreenReducer.ModelOthersList,
    };
}
export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(editEquipment)));
